import { ThietLapDonHangMuaService } from "./../../thiet-lap-don-hang-mua/thiet-lap-don-hang-mua-service/thiet-lap-don-hang-mua.service";

import {
	LichSuGiaoHang,
	ListFileModel,
} from "./../don-hang-mua-page-model/don-hang-mua.model";
import { environment } from "./../../../../../../../environments/environment.prod";
import { FileImport } from "./../../../chuc-nang-kho/kho-de-nghi-nhap-kho/kho-de-nghi-nhap-kho-model/kho-de-nghi-nhap-kho.model";
import { element } from "protractor";
import { DiaChiGiaoHang } from "./../../../khach-hang/khach-hang-model/khach-hang.model";
import { FunctionPublic } from "./../../../dung-chung/__function/common_function";
import { select } from "@ngrx/store";
import {
	Component,
	OnInit,
	ElementRef,
	ViewChildren,
	ViewChild,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Inject,
	HostListener,
	ViewRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
// Material
import {
	MatMenuTrigger,
	MatDialogRef,
	MAT_DIALOG_DATA,
	MatDialog,
} from "@angular/material";
import { SelectionModel } from "@angular/cdk/collections";
import {
	CdkDragStart,
	CdkDropList,
	moveItemInArray,
} from "@angular/cdk/drag-drop";
// RXJS
import { ReplaySubject, BehaviorSubject } from "rxjs";
//Service
import { DonHangMuaService } from "../don-hang-mua-page-service/don-hang-mua.service";
import { DungChungService } from "../../../dung-chung/__services/dung-chung.service";

import { SubheaderService } from "../../../../../../core/_base/layout";
import {
	LayoutUtilsService,
	MessageType,
	QueryParamsModel,
} from "../../../../../../core/_base/crud";
import { TokenStorage } from "../../../../../../core/auth/_services/token-storage.service";
//Model
import {
	DonHangMua,
	DonHangMuaChiTiet,
	SettingDHM,
} from "../don-hang-mua-page-model/don-hang-mua.model";

import {
	FormGroup,
	FormBuilder,
	Validators,
	FormControl,
	ValidatorFn,
} from "@angular/forms";
import moment from "moment";
import { Item } from "@syncfusion/ej2-angular-navigations";
import { CommonConFig } from "../../../dung-chung/__model/common_config.model";
import { stat } from "fs";
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { KeHoachNCCGiaoHangComponent } from "../ke-hoach-ncc-giao-hang/ke-hoach-ncc-giao-hang.component";
import { LichSuGiaMuaHangComponent } from "../lich-su-gia-mua-hang/lich-su-gia-mua-hang.component";
import { LichSuGiaoHangComponent } from "../lich-su-giao-hang/lich-su-giao-hang.component";
import { DuyetDonHangMuaComponent } from "../duyet-don-hang-mua/duyet-don-hang-mua.component";
import { ThietLapDonHangMuaModel } from "../../thiet-lap-don-hang-mua/thiet-lap-don-hang-mua-model/thiet-lap-don-hang-mua.model";
import { NameFile } from "../../../kinh-doanh/kd-thu-hoi-trieu-hoi/kd-thu-hoi-trieu-hoi-model/kd-thu-hoi-trieu-hoi.model";
import { NguyenLieuService } from "../../../nguyen-lieu/nguyen-lieu-service/nguyen-lieu.service";
import { KDDatHangService } from "../../../kinh-doanh/kd-dat-hang/kd-dat-hang-service/kd-dat-hang.service";

@Component({
	selector: "m-don-hang-mua-dialog-detail",
	templateUrl: "./don-hang-mua-dialog-detail.component.html",
	styleUrls: ["../don-hang-mua-page.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe],
})
export class DonHangMuaDialogDetailComponent implements OnInit {
	/*Config Form */
	CONFIG: CommonConFig;
	optionsHinhThucThanhToan: any[] = [];
	optionsPhuongThucThanhToan: any[] = [];
	optionsPhanTramThue: any[] = [];
	optionsLoaiPhieu: any[] = [];

	/* Các trường focus cho các tag trong form */
	@ViewChild("fileUpload1", { static: true }) fileUpload1;
	@ViewChild("fileUpload2", { static: true }) fileUpload2;

	@ViewChildren("focusMaNCC") focusMaNCC;
	@ViewChildren("focusDienGiai") focusDienGiai;
	@ViewChildren("focusThue") focusThue;
	@ViewChildren("focusDKThanhToan") focusDKThanhToan;

	@ViewChildren("focusLyDoTP") focusLyDoTP;
	@ViewChildren("focusLyDoGD") focusLyDoGD;
	@ViewChildren("focusLyDoGDK") focusLyDoGDK;

	/* Trigger menu hiển thị cột cho danh sách */
	@ViewChild("trigger", { static: true }) _trigger: MatMenuTrigger;
	@ViewChild(CdkVirtualScrollViewport, { static: false })
	cdkVirtualScrollViewPort: CdkVirtualScrollViewport;

	/* Comment columns mat-table
		Các trường columns cho bảng:
		- displayedColumns: display ra form
		- availableColumns: các cột sẽ được add vào display.
		- extendsColumns: các cột mở rộng thêm cho display khi QC kiểm tra
	*/
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: "TICK",
			displayName: "",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 1,
			name: "REASON",
			displayName: "",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 1,
			name: "#",
			displayName: "#",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 2,
			name: "MAHH",
			displayName: "Mã hàng",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 3,
			name: "TENHH",
			displayName: "Tên hàng",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 4,
			name: "QUYCACH",
			displayName: "Quy cách",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 5,
			name: "DONVITINH",
			displayName: "ĐVT",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 5,
			name: "SOPHIEUDNMH",
			displayName: "Số phiếu ĐNMH",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 5,
			name: "PBSD",
			displayName: "Phòng ban sử dụng",
			alwaysChecked: false,
			isShow: true,
		},
		// {
		// 	stt: 6,
		// 	name: 'SOLUONGKH',
		// 	displayName: 'SL Kế hoạch',
		// 	alwaysChecked: false,
		// 	isShow: true
		// },
		{
			stt: 6,
			name: "SOLUONG",
			displayName: "SL",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 6,
			name: "SOLUONGHANGVE",
			displayName: "SL hàng về",
			alwaysChecked: false,
			isShow: true,
		},

		{
			stt: 6,
			name: "SOLUONGDAGIAO",
			displayName: "SL đã giao",
			alwaysChecked: false,
			isShow: true,
		},

		{
			stt: 10,
			name: "GHICHU",
			displayName: "Ghi chú",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 7,
			name: "DONGIA",
			displayName: "Đơn giá",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 8,
			name: "THANHTIEN",
			displayName: "Thành tiền",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 8,
			name: "THANHTIENQUYDOI",
			displayName: "Thành tiền quy đổi",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 8,
			name: "PHANTRAMTHUE",
			displayName: "% Thuế",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 8,
			name: "THUE",
			displayName: "Thuế",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 8,
			name: "TRANGTHAIMATHANG",
			displayName: "Trạng thái mặt hàng",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 90,
			name: "FILETIEUCHUAN",
			displayName: "File tiêu chuẩn hàng hóa",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 99,
			name: "ACTIONS",
			displayName: "Thao tác",
			alwaysChecked: true,
			isShow: true,
		},
	];

	columnExtend = [
		{
			stt: 99,
			name: "ACTIONS",
			displayName: "Thao tác",
			alwaysChecked: true,
			isShow: true,
		},
	];

	listFileName: string[] = [];

	/* End comment columns mat-table -------------------------------------*/

	/* Mat select search cho nhà cung cấp */
	listListNCC: any[] = [];
	selectListNCC: string = "";
	filteredListNCC: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListNCCFilterCtrl: string = "";
	haveElementListNCC: boolean = false;
	/* ------------------------------------------------------------------ */

	/* Mat select search cho hop dong */
	listHD: any[] = [];
	selectHD: string = "";
	filteredHD: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	HDFilterCtrl: string = "";
	sumRecordHD = 0;
	haveElementHD: boolean = false;
	/* ------------------------------------------------------------------ */

	/* Mat select search cho hàng hóa */
	listId_HH: any[] = [];
	selectId_HH: string = "";
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = "";
	haveElementId_HH: boolean = false;
	spinnerHD: boolean = false;

	listTienTe: any[] = [];
	selectTienTe: string = "";
	filteredTienTe: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	TienTeFilterCtrl: string = "";
	haveElementTienTe: boolean = false;
	spinnerTienTe: boolean = false;
	/* ------------------------------------------------------------------ */

	/* Giá trị đầu tiên cho dropdown quyết định nhập hàng - Form QC kiểm tra*/
	selectQuyetDinhLoHang = "0";
	/* ------------------------------------------------------------------ */

	listDiaDiemGiaoHang: any[] = [];
	selectDiaDiemGiaoHang: string = "";
	filteredDiaDiemGiaoHang: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	sumRecord = 0;
	sumRecordA = 0;
	DiaDiemGiaoHangFilterCtrl: string = "";
	haveElementDiaDiemGiaoHang: boolean = false;

	/* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<DonHangMuaChiTiet>(true, []);
	/* ------------------------------------------------------------------ */

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* Extend field:  */
	previousIndex: number; // Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2; // Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false; // Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false; // Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedTTHV: number[] = []; // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false; // Loading khi mở dialog
	canEdit: boolean = false; // Dialog có thể chỉnh sửa không?
	/* ------------------------------------------------------------------ */

	/* Các Sub form trên dialog:  */
	DonHangMuaForm: FormGroup; //Form phiếu đề nghị
	DonHangMuaMoneyForm: FormGroup; //Form add hàng hóa cho phiếu
	TitleTable: FormGroup;
	DonHangMuaFormDuyet: FormGroup;
	DonHangMuaGDForm: FormGroup;
	DonHangMuaGDKForm: FormGroup;
	DonHangMuaSubForm: FormGroup;

	DonHangMuaFormInit: FormGroup;

	FileKemGia: FormGroup;
	FileBangChung: FormGroup;
	PTTTForm: FormGroup;
	/* ------------------------------------------------------------------ */

	/* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	DonHangMuaItem: DonHangMua;

	/* Danh sách chi tiết hàng hóa của phiếu đề nghị:  */
	listChiTietHangVe: DonHangMuaChiTiet[] = [];

	/* Danh sách tạm chi tiết hàng hóa của phiếu đề nghị dùng để cập nhập trên lưới  */
	tmpChiTietDonHangMua: any[] = [];

	/* Danh sách chi tiết hàng hóa của phiếu đề nghị lúc đầu dùng để so sánh -> cập nhập trạng thái phiếu */
	compareChiTietHangVe: DonHangMuaChiTiet[] = [];

	/* Danh sách tình trạng phiếu */

	/* Action form */
	__ACTION = 1;
	__CREATE = 1;
	__EDIT = 2;

	/* Parameter liên quan đến giá trị tiền */
	__TIENCHUATHUE = 0;
	__THUE = 0;
	__TONGTIEN = 0;

	openFormDialog: boolean = false;

	payments = [];
	currency_unit = [];
	contract = [];

	TinhTrang = [
		{
			Code: "DHM_DANGSOANTHAO",
			Name: "Đang soạn thảo",
			show: true,
		},
		{
			Code: "DHM_CHOTPDUYET",
			Name: "Chờ TP duyệt",
			show: true,
		},
		{
			Code: "DHM_DANGTHUCHIEN",
			Name: "Đang thực hiện",
			show: true,
		},
		{
			Code: "DHM_DANGTHUCHIEN",
			Name: "Đang thực hiện",
			show: false,
		},
		{
			Code: "DHM_CHODONGPO",
			Name: "Chờ đóng PO",
			show: true,
		},
		{
			Code: "DHM_KHONGDUYET",
			Name: "Không duyệt",
			show: true,
		},
		{
			Code: "DHM_HOANTAT",
			Name: "Hoàn tất",
			show: true,
		},
		{
			Code: "DHM_DAHUY",
			Name: "Đã hủy",
			show: true,
		},
		{
			Code: "DHM_DAXOA",
			Name: "Đã xóa",
			show: false,
		},
	];

	//#region Phan loai va vung
	area_1: boolean = false;
	area_2: boolean = false;
	area_3: boolean = false;
	area_4: boolean = false;
	add: boolean = false;
	edit: boolean = false;
	view: boolean = false;
	confirm: boolean = false;
	confirm_level_tp = false;
	confirm_level_gdk = false;
	confirm_level_gd = false;
	//#endregion
	displayedColumnsFile = ["STT", "File", "GhiChu", "ThaoTac"];
	displayedPTTT = ["PHANTRAMTT", "SONGAY", "HINHTHUC", "GHICHU", "THAOTAC"];
	listPTTT = [];
	listFileDinhKem: FileImport[] = [];
	listFileBangChung: FileImport[] = [];
	fileBangChung: FileImport;
	FileDinhKemTmp: FileImport = null;
	listFileDinhKemInit = [];
	listFileBangChungInit = [];
	tmpChiTietDonHangMuaInit = [];
	url_current = "them-moi";
	linkAPI = "";
	listHanMucPB = [];
	listHanMucDuyetPB = [];
	warning: boolean = false;
	spinnerLoadDataHD: boolean = false;
	dataHD: any = null;
	waittingExport: boolean = false;
	LIST_ROLES_USER: [] = [];
	XEM_HD = "06004";
	SHOW_VIEW_CONTRACT = new BehaviorSubject<boolean>(false);
	routeLink: string = "";
	hinhthucthanhtoan: string = "";
	sumChuaThue: string = "";
	sumThue: string = "";
	sumCoThue: string = "";
	sumSL: string = "";

	listChecked: DonHangMuaChiTiet[] = [];
	reasons = "";

	// CONST PERCENT
	PERCENT_MIN = 0.01;
	PERCENT_MAX = 100.00;
	PERCENT_STEP = 0.01;
	MIN_DATE = 1;
	STEP_DATE = 1;
	CKD_ITEM_SIZE = 50;
	CKD_MIN_BUFF = 200;
	CKD_MAX_BUFF = 400;
	MAX_RECORD = 4;
	VALUE_HEIGHT = 48;
	EXCHANGE_RATE_MIN = 0;
	NUMBER_MIN = 0;

	// PTTT OPTION
	OPTION_PTTT = [
		{
			value: 1,
			name: "Sau khi nhận hàng",
			req_note: false,
			default: true
		},
		{
			value: 2,
			name: "Sau khi nhận hóa đơn",
			req_note: false,
			default: false
		},
		{
			value: 3,
			name: "Khác",
			req_note: true,
			default: false
		}
	]

	tabIndex = 0;
	constructor(
		private DonHangMuaService: DonHangMuaService,
		private DungChungService: DungChungService,
		public dialogNCC: MatDialog,
		private DonHangMuaFB: FormBuilder,
		private DonHangMuaFBDuyet: FormBuilder,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private router: Router,
		private route: ActivatedRoute,
		private el: ElementRef,
		private ThietLapDonHangMuaService: ThietLapDonHangMuaService,
		private subheaderService: SubheaderService,
		private service: ThietLapDonHangMuaService,
		private FileKemGiaFB: FormBuilder,
		private FileBangChungFB: FormBuilder,
		private PTTTFormFB : FormBuilder,
		private elementRef: ElementRef,
		private nguyenLieuService: NguyenLieuService,
		private KDDatHangService: KDDatHangService,
		public dialogRef: MatDialogRef<DonHangMuaDialogDetailComponent>,
		public dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		this.LIST_ROLES_USER = user.roles;
	}

	/** LOAD DATA */
	ngOnInit() {
		this.routeLink = window.location.origin;
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.linkAPI = environment.ApiRoot.split("/")[0];
		this.optionsHinhThucThanhToan = SettingDHM.optionsHinhThucThanhToan;
		this.optionsPhuongThucThanhToan = SettingDHM.optionsPhuongThucThanhToan;
		this.optionsPhanTramThue = SettingDHM.optionsPhanTramThue;
		this.optionsLoaiPhieu = SettingDHM.optionsLoaiPhieu;
		this.DonHangMuaItem = new DonHangMua();
		this.DonHangMuaItem.clear();
		this.ListNCC();
		this.ListId_HH();
		this.getPayments();
		this.getCurrentUnit();
		this.createForm();
		this.createFormDuyet();
		this.updateTongTienChuaThue();
		this.getListDiaDiemGiaoHang();
		this.showAreaWithAction();
		this.showColumnsInTable();
		this.applySelectedColumns();
		this.getDieuKienGiaoHang();
		this.DonHangMuaFormInit = this.DonHangMuaForm.value;
		this.DonHangMuaFormInit["SOHD"] = "";
		if(this.data.IdPOMua) this.bidingData(this.data.IdPOMua);
		this.changeDetect.detectChanges();
	}

	/*Create Form with appropriate sub forms */
	createForm() {
		var tenNguoiLap = "";
		this.tokenStorage.getFullName().subscribe((t) => {tenNguoiLap = t;});
		let item = this.DonHangMuaItem;
		this.DonHangMuaForm = this.DonHangMuaFB.group({
			SOPHIEU: [this.DonHangMuaItem.SoPhieu, Validators.required],
			NGAYLAP: [
				!(
					this.DonHangMuaItem.ThoiGianTao == undefined ||
					this.DonHangMuaItem.ThoiGianTao == ""
				)
					? this.DonHangMuaItem.ThoiGianTao
					: new Date(),
				Validators.required,
			],
			NGUOILAP: [
				this.DonHangMuaItem.NguoiTao > 0
					? this.DonHangMuaItem.TenNguoiTao
					: tenNguoiLap,
			],
			TRANGTHAI: [
				this.DonHangMuaItem.TinhTrang_Code == ""
					? this.TinhTrang[0].Code
					: this.DonHangMuaItem.TinhTrang_Code,
			],
			DESCTRANGTHAI: [
				this.DonHangMuaItem.TinhTrang_Name == ""
					? this.TinhTrang[0].Name
					: this.DonHangMuaItem.TinhTrang_Name,
			],
			NGAYDAT: [new Date(), Validators.required],
			MANCC: [
				this.DonHangMuaItem.IdNCC > 0
					? "" + this.DonHangMuaItem.IdNCC
					: "",
				Validators.required,
			],
			TENNCC: [
				this.DonHangMuaItem.TenNCC ? this.DonHangMuaItem.TenNCC : "",
			],
			NGUOILIENHE: [
				this.DonHangMuaItem.NguoiLienHe
					? this.DonHangMuaItem.NguoiLienHe
					: "",
			],
			DIENTHOAI: [
				this.DonHangMuaItem.DienThoai
					? this.DonHangMuaItem.DienThoai
					: "",
			],
			DIACHI: [
				this.DonHangMuaItem.DiaChi ? this.DonHangMuaItem.DiaChi : "",
			],
			DIADIEMGIAOHANG: ["", Validators.required],
			HINHTHUCTHANHTOAN: [
				this.optionsHinhThucThanhToan
					.filter((x) => x.Default)
					.map((a) => a.Code)[0],
				Validators.required,
			],
			COHOADON: [false],
			PHUONGTHUCTHANHTOAN: [
				this.optionsPhuongThucThanhToan
					.filter((x) => x.Default)
					.map((a) => a.Code)[0],
				Validators.required,
			],
			PHANTRAMTT: [
				0.0,
				Validators.compose([
					Validators.min(0.01),
					Validators.max(100.0),
				]),
			],
			THOIGIANTT: [0, Validators.min(1)],
			SOHD: [""],
			BANGCHUNGNCCXACNHAN: [""],
			DIEUKIENGH: ["", Validators.required],
			FILENAME: [""],
			LOAITIEN: ["", Validators.required],
			TYGIA: ["1,00", Validators.required],
			TONGTIENCHUATHUE: ["0", Validators.required],
			TONGTIENTHUE: ["0", Validators.required],
			TONGTIENPHAITRA: ["0", Validators.required],
			LOAIPHIEU: [
				this.optionsLoaiPhieu
					.filter((x) => x.Default)
					.map((a) => a.Code)[0],
				Validators.required,
			],
			DESCRIPTION : [],
			INVOICENO: [""]
		});

		this.DonHangMuaForm.disable();
		this.changePhuongThucThanhToan(
			this.optionsPhuongThucThanhToan
				.filter((x) => x.Default)
				.map((a) => a.Code)[0]
		);

		this.FileKemGia = this.FileKemGiaFB.group({
			FILENAME: ["", Validators.required],
			GHICHU: [""],
		});

		this.FileBangChung = this.FileBangChungFB.group({
			FILENAME: ["", Validators.required],
			GHICHU: [""],
		});

		this.PTTTForm = this.PTTTFormFB.group({
			PER_PAYMENT: [0.0,Validators.compose([Validators.required, Validators.min(0.01), Validators.max(100.0)])],
			NUMBER_DATE: [0, Validators.compose([Validators.min(1), Validators.required])],
			TYPE_PAYMENT: [""+this.getValuePTTTDefault(), Validators.required],
			NOTE: [""]
		});
	}

	createFormDuyet() {
		/*Get name of người lập phiếu */
		var tenNguoiLap = "";
		this.tokenStorage.getFullName().subscribe((t) => {
			tenNguoiLap = t;
		});
		let item = this.DonHangMuaItem;
		this.DonHangMuaFormDuyet = this.DonHangMuaFBDuyet.group({
			TPDUYET: [
				!item.Name_TPDuyet
					? this.url_current == "duyet"
						? tenNguoiLap
						: ""
					: item.Name_TPDuyet,
			],
			NGAYTPDUYET: [
				item.Date_TPDuyet
					? item.Date_TPDuyet
					: this.url_current == "duyet"
						? new Date()
						: "",
			],
			TPLYDO: [
				item.LyDo_TPDuyet == null || item.LyDo_TPDuyet == ""
					? ""
					: item.LyDo_TPDuyet,
			],

			GDKDUYET: [
				!item.Name_GDKDuyet
					? this.url_current == "duyet"
						? tenNguoiLap
						: ""
					: item.Name_GDKDuyet,
			],
			NGAYGDKDUYET: [
				item.Date_GDKDuyet
					? item.Date_GDKDuyet
					: this.url_current == "duyet"
						? new Date()
						: "",
			],
			GDKLYDO: [
				item.LyDo_GDKDuyet == null || item.LyDo_GDKDuyet == ""
					? ""
					: item.LyDo_GDKDuyet,
			],

			GDDUYET: [
				!item.Name_GDDuyet
					? this.url_current == "duyet"
						? tenNguoiLap
						: ""
					: item.Name_GDDuyet,
			],
			NGAYGDDUYET: [
				item.Date_GDDuyet
					? item.Date_GDDuyet
					: this.url_current == "duyet"
						? new Date()
						: "",
			],
			GDLYDO: [
				item.LyDo_GDDuyet == null || item.LyDo_GDDuyet == ""
					? ""
					: item.LyDo_GDDuyet,
			],
		});
		this.DonHangMuaFormDuyet.disable();
	}

	//#region Get hình thức thanh toán, hop dong, tien te
	async getPayments() {
		let res = await this.DungChungService.getHinhThucThanhToan().toPromise();
		if (res && res.status === 1) {
			this.payments = res.data;
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
		this.changeDetect.detectChanges();
	}

	async getCurrentUnit() {
		let resCurrency = await this.KDDatHangService.getConfigDefaultCurrency().toPromise();
		if (resCurrency && resCurrency.status === 1) {
			let idDefaultCurrency = Number(resCurrency.data);

			let res = await this.DungChungService.getDSTienTe().toPromise();
			if (res && res.status === 1) {
				this.currency_unit = res.data;
				this.filteredTienTe.next(this.currency_unit.slice());

				if (this.currency_unit.length > 0) {
					if (!this.DonHangMuaForm.controls["LOAITIEN"].value) {
						let indexVND = this.currency_unit.findIndex(
							(x) => +x.Id == idDefaultCurrency
						);
						if (indexVND > -1)
							this.DonHangMuaForm.controls["LOAITIEN"].setValue(this.currency_unit[indexVND].Id.toString()
							);
						else
							this.DonHangMuaForm.controls["LOAITIEN"].setValue(this.currency_unit[0].Id.toString()
							);
						this.DonHangMuaFormInit[
							"LOAITIEN"
						] = this.currency_unit[
							indexVND > -1 ? indexVND : 0
						].Id.toString();
					}
				}
			} else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
			this.changeDetect.detectChanges();
		}
	}

	async getHopDongTheoNCC(id) {
		let res = await this.DungChungService.getHopDongTheoNCC(id).toPromise();
		if (res && res.status === 1) {
			this.listHD = res.data;
			this.filteredHD.next(this.listHD.slice());
			this.changeDetect.detectChanges();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
		this.changeDetect.detectChanges();
	}

	changePhuongThucThanhToan(event: any) {
		var value = event.value ? event.value : event;
		if (value) {
			if (value == this.optionsPhuongThucThanhToan[0].Code) {
				this.DonHangMuaForm.controls["PHANTRAMTT"].setValidators([
					Validators.compose([
						Validators.min(0.01),
						Validators.max(100.0),
						Validators.required,
					]),
				]);
				this.DonHangMuaForm.controls[
					"PHANTRAMTT"
				].updateValueAndValidity();

				this.DonHangMuaForm.controls["THOIGIANTT"].clearValidators();
				this.DonHangMuaForm.controls[
					"THOIGIANTT"
				].updateValueAndValidity();
				this.DonHangMuaForm.controls["THOIGIANTT"].setValue(0);

			}

			if (value == this.optionsPhuongThucThanhToan[1].Code) {
				this.DonHangMuaForm.controls["PHANTRAMTT"].clearValidators();
				this.DonHangMuaForm.controls[
					"PHANTRAMTT"
				].updateValueAndValidity();

				this.DonHangMuaForm.controls["PHANTRAMTT"].setValue(0.0);

				this.DonHangMuaForm.controls["THOIGIANTT"].setValidators([
					Validators.compose([
						Validators.required,
						Validators.min(1),
						Validators.pattern("^[1-9]([0-9]+)?$"),
					]),
				]);
				this.DonHangMuaForm.controls[
					"THOIGIANTT"
				].updateValueAndValidity();
			}
		}
	}

	filterTienTe() {
		if (!this.currency_unit) {
			return;
		}
		// get the search keyword
		let search = this.TienTeFilterCtrl;
		if (!search) {
			this.filteredTienTe.next(this.currency_unit.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredTienTe.next(
			this.currency_unit.filter(
				(ts) =>
					(ts.Ma + " - " + ts.Ten).toLowerCase().indexOf(search) > -1
			)
		);
		this.changeDetect.detectChanges();
	}

	filterListHD() {
		if (!this.listHD) {
			return;
		}
		// get the search keyword
		let search = this.HDFilterCtrl;
		if (!search) {
			this.filteredHD.next(this.listHD.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredHD.next(
			this.listHD.filter(
				(ts) => ts.So_HD.toLowerCase().indexOf(search) > -1
			)
		);
		this.changeDetect.detectChanges();
	}
	//#endregion Get hình thức thanh toán, hop dong, tien te

	//#region checkPositiveNumbers
	checkPositiveNumbers(event) {
		FunctionPublic.checkPositiveNumbers(event);
	}

	changeInputNumber(event, columnName, min: number = 0, formGroup: any) {
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		} else {
			if (
				event.keyCode === 46 ||
				event.keyCode === 37 ||
				event.keyCode === 39 ||
				event.keyCode === 8 ||
				event.keyCode === 9
			) {
				return;
			}

			let data = Number(event.target.value);
			if (data) {
				if (data < min) data = min;
				formGroup.controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				this.changeDetect.detectChanges();
			}
		}
	}

	changeInputNuberOutInput(
		controlName: string,
		event: any,
		min: number = 0,
		formGroup: any
	) {
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = Number(formGroup.controls[controlName].value);
			if (tmpValue < min) tmpValue = min;
			if (!formGroup.controls[controlName].invalid) {
				formGroup.controls[controlName].setValue(tmpValue);
				return;
			}
			formGroup.controls[controlName].setValue(min);
		} else {
			formGroup.controls[controlName].setValue(min);
		}
	}
	//#endregion checkPositiveNumbers

	/*Lấy tiêu đề cho dialog với các TH thêm - sửa - QC kiểm tra*/
	getTitle(): string {
		return "CHI TIẾT ĐƠN HÀNG MUA";
	}

	/*Xóa dữ liệu hàng hóa trong bảng*/
	deleteItem(item: any) {
		let index = this.tmpChiTietDonHangMua.indexOf(item, 0);
		if (index > -1) {
			this.tmpChiTietDonHangMua.splice(index, 1);
		}

		var count_hh = this.tmpChiTietDonHangMua.filter(
			(x) => x.RecordSumAmount == false && x.IdHH == item.IdHH
		).length;
		if (count_hh == 1) {
			var last_index = this.tmpChiTietDonHangMua.findIndex(
				(x) => x.RecordSumAmount && x.IdHH == item.IdHH
			);
			this.tmpChiTietDonHangMua.splice(last_index, 1);
		}
		this.tmpChiTietDonHangMua = [...this.tmpChiTietDonHangMua];
		this.checkHangHoaHopDong();
		this.checkSLWithSLConLaiHD();
		this.setDonGiaHDInList();
		this.callSum();
	}

	/*Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column) return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(
				this.availableColumns,
				this.previousIndex,
				this.findIndexColumn(column)
			);
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(
			true,
			this.availableColumns
		);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		// if(this.add || this.edit){
		// 	this.columnExtend.forEach(element => {
		// 		this.availableColumns.splice(this.availableColumns.length, 0 ,element);
		// 	});
		// 	this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		// }
		this.selectedColumns.selected.forEach((col) => {
			_applySelectedColumns.push(col.name);
		});
		this.displayedColumns = _applySelectedColumns;
	}
	/*---------------------------------------------------------------------------------------- */

	/*Các hàm hỗ trợ cho mat select search Nhà cung cấp*/
	ListNCC() {
		this.DungChungService.listNCC().subscribe((res) => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listListNCC = res.data;
				var data = window.history.state;
				if (data != null && data.IsKeHoachMuaHang) {
					this.afterSelectNCC(this.selectListNCC);
				}
				this.sumRecord = this.listListNCC.length;
				this.filteredListNCC.next(this.listListNCC.slice());
				this.changeDetect.detectChanges();
			}
		});
	}
	filterListNCC(searchTmp: string = "") {
		if (!this.listListNCC) {
			return;
		}
		// get the search keyword
		let search = this.ListNCCFilterCtrl;

		if (searchTmp != "") search = "" + searchTmp;

		if (!search) {
			this.sumRecord = this.listListNCC.length;
			this.filteredListNCC.next(this.listListNCC.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if (searchTmp != "") {
			this.sumRecord = this.listListNCC.filter(
				(ts) =>
					(ts.MaNCC + " - " + ts.TenNCC)
						.toLowerCase()
						.indexOf(search) > -1
			).length;
			this.filteredListNCC.next(
				this.listListNCC.filter(
					(ts) =>
						(ts.MaNCC + " - " + ts.TenNCC)
							.toLowerCase()
							.indexOf(search) > -1
				)
			);
		} else {
			this.sumRecord = this.listListNCC.filter(
				(ts) =>
					(ts.MaNCC + " - " + ts.TenNCC)
						.toLowerCase()
						.indexOf(search) > -1
			).length;
			this.filteredListNCC.next(
				this.listListNCC.filter(
					(ts) =>
						(ts.MaNCC + " - " + ts.TenNCC)
							.toLowerCase()
							.indexOf(search) > -1
				)
			);
		}
	}
	/*------------------------------------------ */

	/*Hàm hỗ trợ format các dạng số trên form*/
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		let data: string = "";
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ",") {
					count += 1;
				}
			}
			data = event.target.value;
		} else {
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ",") {
					count += 1;
				}
			}
			data = event;
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent
			? event.target.value.match(regex)
			: String(event).match(regex);
		if (found != null) {
			return false;
		}
		if (count >= 2) {
			return false;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == "" || item == null || item == undefined) return "";
		return Number(
			Math.round(parseFloat(item + "e" + this.fixedPoint)) +
			"e-" +
			this.fixedPoint
		).toFixed(this.fixedPoint);
	}
	f_currency(value: string): any {
		value = String(value);
		if (value == null || value == undefined || value == "") value = "0.00";
		let nbr = Number(
			(
				value.substring(0, value.length - (this.fixedPoint + 1)) + ""
			).replace(/,/g, "")
		);
		return (
			(nbr + "").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +
			value.substr(
				value.length - (this.fixedPoint + 1),
				this.fixedPoint + 1
			)
		);
	}
	f_currency_V2(value: string): any {
		value = String(value);
		if (value == "-1") return "";
		if (value == null || value == undefined || value == "") value = "0";
		let nbr = Number((value + "").replace(/,/g, ""));
		return (nbr + "").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	/*------------------------------------------------------------- */

	/*Hàm hỗ trợ format các dạng ngày trên form*/
	getFormatDate(v: string = "") {
		if (v != "") {
			return v.includes("T")
				? v.replace(
					/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g,
					"$5/$3/$1"
				)
				: v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return "";
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == "") return "";
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return (
			("0" + a.getDate()).slice(-2) +
			"/" +
			("0" + (a.getMonth() + 1)).slice(-2) +
			"/" +
			a.getFullYear()
		);
	}
	/*------------------------------------------------------------- */

	async createBillNumber() {
		var category_path = "DHM";
		var res = await this.DungChungService.getBillNumber(category_path)
			.toPromise()
			.then((r) => {
				return r;
			});
		if (res && res.status == 1) {
			return res.data;
		} else {
			this.layoutUtilsService.showErorr(
				"Không thể lấy số phiếu tự động."
			);
		}
	}
	/* Chọn Mã NCC */
	selectedMaNCC(change: boolean = false) {
		let indexNCC = -1;
		let Id =
			this.__ACTION == this.__CREATE || change
				? +this.DonHangMuaForm.controls["MANCC"].value
				: +this.DonHangMuaItem.IdNCC;
		indexNCC = this.listListNCC.findIndex((x) => x.Id_NCC == Id);
		if (indexNCC > -1) {
			let NCC = this.listListNCC[indexNCC];
			if (NCC) {
				this.DonHangMuaForm.controls["TENNCC"].setValue(NCC.TenNCC);
				this.DonHangMuaForm.controls["NGUOILIENHE"].setValue(
					NCC.NguoiLienHe
				);
				this.DonHangMuaForm.controls["DIENTHOAI"].setValue(
					NCC.DienThoai
				);
				this.DonHangMuaForm.controls["DIACHI"].setValue(NCC.DiaChi);
				//this.getListHopDong(+NCC.Id_NCC);

				// if(change == false){
				// 	this.tmpChiTietDonHangMua = [];
				// 	this.tmpChiTietDonHangMua = [...this.tmpChiTietDonHangMua];
				// 	this.DonHangMuaForm.controls['TONGTIENCHUATHUE'].setValue(0);
				// 	this.DonHangMuaForm.controls['TONGTIENTHUE'].setValue(0);
				// 	this.DonHangMuaForm.controls['TONGTIENPHAITRA'].setValue(0);
				// }

				this.changeDetect.detectChanges();
			}
		}
	}

	//#region Chuyển trạng thái phiếu
	checkGuiDuyet(checked: boolean = false) {
		if (checked) {
			this.DonHangMuaForm.controls["DESCTRANGTHAI"].setValue(
				this.TinhTrang[1].Name
			);
			this.DonHangMuaForm.controls["TRANGTHAI"].setValue(
				this.TinhTrang[1].Code
			);
		} else {
			this.DonHangMuaForm.controls["DESCTRANGTHAI"].setValue(
				this.TinhTrang[0].Name
			);
			this.DonHangMuaForm.controls["TRANGTHAI"].setValue(
				this.TinhTrang[0].Code
			);
		}
	}
	//#endregion Chuyển trạng thái phiếu

	/* Tổng tiền theo phần trăm số */
	caculatorMoney() {
		this.__TONGTIEN =
			this.__TIENCHUATHUE + this.__TIENCHUATHUE * this.__THUE;
		return this.__TONGTIEN;
	}

	/* Cập nhật lại tổng tiền chưa thuế */
	updateTongTienChuaThue() {
		let sum = 0;
		this.tmpChiTietDonHangMua.forEach((x) => {
			sum += x.ThanhTienQuyDoi;
		});
		this.__TIENCHUATHUE = sum;
		this.__TONGTIEN = this.caculatorMoney();
	}

	/* Mở danh sách phiếu đề nghị */
	validateInvalidForm(isAddDetail: boolean = false) {
		const controls = this.DonHangMuaForm.controls;
		if (this.DonHangMuaForm.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll(
				".ng-invalid"
			);
			if (invalidElements.length > 0) {
				for (let i = 0; i < invalidElements.length; i++) {
					if (
						invalidElements[i].nodeName == "INPUT" ||
						invalidElements[i].nodeName == "MAT-SELECT"
					) {
						const elementControl = this.DonHangMuaForm.get(
							invalidElements[i].attributes.getNamedItem(
								"formcontrolname"
							).value
						);
						if (elementControl) {
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach((controlName) =>
				controls[controlName].markAsTouched()
			);

			return false;
		}

		if (!isAddDetail) {
			this.forcusAnotherEmptyField(controls);
		}
		return true;
	}
	closeDropdownEvent(dropdownName: string) {
		if (dropdownName == "MaNCC") {
			setTimeout(() => this.focusMaNCC.first.close(), 0);
			this.changeDetect.detectChanges();
		}

		//this.validateInvalidForm();
		this.changeDetect.detectChanges();
	}

	forcusAnotherEmptyField(control: any) {
		let run: boolean = true;
		Object.keys(control).forEach((controlName) => {
			if (
				(control[controlName].value == null ||
					control[controlName].value == undefined ||
					control[controlName].value == "") &&
				run
			) {
				// if(controlName == 'DKTHANHTOAN'){
				// 	setTimeout(() => this.focusDKThanhToan.first.nativeElement.focus(), 0);
				// 	run = false;
				// 	this.changeDetect.detectChanges();
				// }
				// if(controlName == 'DIENGIAI'){
				// 	setTimeout(() => this.focusDienGiai.first.nativeElement.focus(), 0);
				// 	run = false;
				// 	this.changeDetect.detectChanges();
				// }
			}
		});
	}

	clearSelectNCC(event: any = null) {
		this.selectListNCC = "";
		this.DonHangMuaForm.controls["MANCC"].setValue("");
		this.DonHangMuaForm.controls["MANCC"].enable();
		this.DonHangMuaForm.controls["TENNCC"].setValue("");
		this.DonHangMuaForm.controls["NGUOILIENHE"].setValue("");
		this.DonHangMuaForm.controls["DIENTHOAI"].setValue("");
		this.DonHangMuaForm.controls["DIACHI"].setValue("");
		this.listHD = [];
		if (event != null) event.stopPropagation();
		//this.getListHopDong();
		//setTimeout(() => this.focusMaNCC.first.open(), 500);
		this.changeDetect.detectChanges();
	}

	clearSelectHD() {
		this.selectHD = "";
		this.DonHangMuaForm.controls["SOHD"].setValue("");
		this.DonHangMuaForm.controls["SOHD"].enable();
		//this.clearSelectNCC();
		this.DonHangMuaForm.controls["DIADIEMGIAOHANG"].setValue("");
		this.DonHangMuaForm.controls["HINHTHUCTHANHTOAN"].setValue(
			this.optionsHinhThucThanhToan
				.filter((x) => x.Default)
				.map((x) => x.Code)[0]
		);
		this.DonHangMuaForm.controls["PHUONGTHUCTHANHTOAN"].setValue(
			this.optionsPhuongThucThanhToan
				.filter((x) => x.Default)
				.map((x) => x.Code)[0]
		);
		this.changePhuongThucThanhToan(
			this.optionsPhuongThucThanhToan
				.filter((x) => x.Default)
				.map((x) => x.Code)[0]
		);
		this.listFileDinhKem = [];
		this.getDieuKienGiaoHang();

		// if(this.DonHangMuaForm.controls['LOAIPHIEU'].value == "0") this.resetListDetails();
		this.checkHangHoaHopDong();
		this.checkSLWithSLConLaiHD();
		this.setDonGiaHDInList();
		this.changeDetect.detectChanges();
	}

	resetListDetails() {
		var data = {
			listId: this.tmpChiTietDonHangMua.map((x) => x.IdDNMH),
		};

		this.DonHangMuaService.getDetailsKHMHWithListId(data).subscribe(
			(res) => {
				if (res && res.status == 1) {
					this.tmpChiTietDonHangMua.forEach((row) => {
						var khmh = res.data.find((x) => x.IdDNMH == row.IdDNMH);
						if (khmh) {
							row.SoLuong = khmh.SoLuong;
							row.DonGia = khmh.DonGia;
							row.ThanhTien = row.SoLuong * row.DonGia;
							row.ThanhTienQuyDoi =
								row.ThanhTien *
								Number(
									this.f_number(
										this.DonHangMuaForm.controls["TYGIA"]
											.value
									));
							row.PhanTramThue = this.optionsPhanTramThue[0].Code;
							row.TienThue =
								(row.ThanhTienQuyDoi *
									this.optionsPhanTramThue[0].Value) /
								100;
						}
					});
					this.tmpChiTietDonHangMua = [...this.tmpChiTietDonHangMua];
					this.changeDetect.detectChanges();
				} else {
					this.layoutUtilsService.showErorr(
						"Không thể reset lại giá chi tiết đơn hàng mua"
					);
				}
			}
		);
	}

	//#region Cập nhat thành tiền quy đổi
	// updateThanhTienQuyDoi(){
	// 	let tygia = this.formatComparenumber(this.TitleTable.controls['TYGIA'].value.toString());
	//
	// 	this.tmpChiTietDonHangMua.forEach(x => {
	// 		x.ThanhTien = this.formatComparenumber(x.SoLuong.toString()) * this.formatComparenumber(x.DonGia.toString());
	// 		x.ThanhTienQuyDoi = this.formatComparenumber(x.SoLuong.toString()) * this.formatComparenumber(x.DonGia.toString()) * tygia;
	// 	});
	// 	this.refreshList();
	// }
	//#endregion Cập nhat thành tiền quy đổi

	//#region Cập nhat thuế
	// updateThueGTGT(){
	// 	let thue = +(this.DonHangMuaMoneyForm.controls['THUE'].value.replace(/,/g, ""));
	// 	if(!thue) thue = 0;
	// 	this.DonHangMuaMoneyForm.controls['THUE'].setValue(this.f_currency_VND(this.formatNumber(thue.toString())));
	// 	this.updateMoney();
	// 	this.changeDetect.detectChanges();
	// }
	//#endregion Cập nhat thuế

	//#region Cập nhat lại list
	// refreshList(){
	// 	let tmp = this.tmpChiTietDonHangMua;
	// 	this.tmpChiTietDonHangMua = [];
	// 	this.tmpChiTietDonHangMua = [...tmp];
	// 	this.updateMoney();
	// 	this.changeDetect.detectChanges();
	// }
	//#endregion Cập nhat lại list

	//#region Cap nhat ty gai dang tien te
	// changeInputCurrency(event, columnName, formGroup){
	// 	let position = event.target.selectionStart;
	// 	let sizeStart = event.target.value.toString().length;
	// 	let sizeEnd = sizeStart;
	// 	var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
	// 	var found = event.target.value.match(regex);
	// 	if (found != null) {
	// 		event.preventDefault();
	// 	}
	// 	else{
	// 		if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9)
	// 		{ return; }

	// 		let data = FunctionPublic.slListChanged(event);
	// 		if(data){
	// 			formGroup.controls[columnName].setValue(data);
	// 			this.updateThanhTienQuyDoi();
	// 			this.updateMoney();
	// 		}
	// 		sizeEnd = data.toString().length;
	// 		let balance = sizeEnd - sizeStart;
	// 		event.target.selectionStart = position + balance;
	// 		event.target.selectionEnd = position + balance;
	// 		this.changeDetect.detectChanges();
	// 	}
	// }
	//#endregion

	//#region An hien vung theo thao tac
	showAreaWithAction() {
		if (this.add || this.edit) this.area_1 = true;
		if (this.view || this.confirm) {
			if (this.confirm_level_tp) this.area_2 = true;
			if (this.confirm_level_gdk) this.area_3 = true;
			if (this.confirm_level_gd) this.area_4 = true;
		}
		this.changeDetect.detectChanges();
	}
	//#endregion

	//#region Set thao tac
	setActionDialog(data) {
		if (data.add) this.add = true;
		if (data.edit) this.edit = true;
		if (data.view) this.view = true;
		if (data.confirm) this.confirm = true;
		if (data.confirm_level_tp) this.confirm_level_tp = true;
		if (data.confirm_level_gdk) {
			this.confirm_level_tp = true;
			this.confirm_level_gdk = true;
		}
		if (data.confirm_level_gd) {
			this.confirm_level_gd = true;
			this.confirm_level_tp = true;
			this.confirm_level_gdk = true;
		}
	}
	//#endregion

	errorPayment(){
		let MAX_PERCENT_PAYMENT = 100;
		var sumPercent = this.listPTTT.map(x => x.per_payment).reduce((a, b) => Number(a) + Number(b));
		if(this.isPaymentPrepay()){
			let prepay = +this.DonHangMuaForm.controls['PHANTRAMTT'].value;
			sumPercent += prepay;
		}
		return sumPercent != MAX_PERCENT_PAYMENT;
	}

	//#region Goi api thêm moi, chinh sua
	setMua_PhieuDatHang(status: number = 0) {
		if (this.errorPayment()) {
			const message = "Vui lòng xem lại dữ liệu thanh toán.";
			this.layoutUtilsService.showErorr(message);
			this.tabIndex = 3;
			return false;
		}
		if (this.invalidForm(this.DonHangMuaForm) == false) return;
		if (this.tmpChiTietDonHangMua.length == 0) {
			const message = "Vui lòng thêm chi tiết phiếu mua hàng.";
			this.layoutUtilsService.showErorr(message);
			return false;
		}
		let flag = false;
		let flagDonGia = false;
		let flagSoLuong = false;
		let arrNoHaveInHD = [];
		let arrOverSLHD = [];
		this.tmpChiTietDonHangMua
			.filter((x) => x.RecordSumAmount == false)
			.forEach((e) => {
				if (e.isError === true) flag = true;
				if (e.DonGia == 0 || !e.DonGia) flagDonGia = true;
				if (e.SoLuong == 0 || !e.SoLuong) flagSoLuong = true;
				if (this.selectHD) {
					if (!e.IsHaveInHD) {
						arrNoHaveInHD.push(
							this.tmpChiTietDonHangMua
								.filter((x) => x.RecordSumAmount == false)
								.indexOf(e) + 1
						);
					}
					if (e.IsOverSLConLaiHD) {
						arrOverSLHD.push(
							this.tmpChiTietDonHangMua
								.filter((x) => x.RecordSumAmount == false)
								.indexOf(e) + 1
						);
					}
				}
			});

		if (flagSoLuong) {
			const message = "Vui lòng nhập trường số lượng.";
			this.layoutUtilsService.showErorr(message);
			this.tabIndex = 1;
			return false;
		}

		if (flagDonGia) {
			const message = "Vui lòng nhập trường đơn giá.";
			this.layoutUtilsService.showErorr(message);
			this.tabIndex = 1;
			return false;
		}
		if (flag) {
			const message =
				"Vui lòng chỉnh sửa dòng dữ liệu lỗi trước khi lưu.";
			this.layoutUtilsService.showErorr(message);
			this.tabIndex = 1;
			return false;
		}
		if (arrNoHaveInHD.length > 0) {
			const message =
				"Không được tồn tại mặt hàng không có trong hợp đồng.";
			this.layoutUtilsService.showErorr(message);
			this.tabIndex = 1;
			return false;
		}
		if (arrOverSLHD.length > 0) {
			const message =
				"Không được tồn tại mặt hàng vượt quá số lượng còn lại trong hợp đồng.";
			this.layoutUtilsService.showErorr(message);
			this.tabIndex = 1;
			return false;
		}
		let flagKeHoach = 0;
		this.tmpChiTietDonHangMua
			.filter((x) => x.RecordSumAmount == false)
			.forEach((e) => {
				const reducer = (accumulator, currentValue) =>
					Number(accumulator) + Number(currentValue);
				var SLDaLenKH =
					e.KeHoachNCCGiaoHang.length == 0
						? 0
						: e.KeHoachNCCGiaoHang.map((x) => x.SoLuong).reduce(
							reducer
						);
				if (SLDaLenKH != e.SoLuong && flagKeHoach == 0)
					flagKeHoach = this.tmpChiTietDonHangMua.indexOf(e) + 1;
			});

		if (flagKeHoach) {
			const message =
				"Vui lòng thêm kế hoạch ncc giao hàng ở dòng chi tiết thứ " +
				flagKeHoach;
			this.layoutUtilsService.showErorr(message);
			this.tabIndex = 1;
			return false;
		}
		const data = this.createItem();
		const _sophieu: string = data.SoPhieu;
		if (data) {
			if (status == 1 || status == 2) {
				data.TinhTrang_Code = this.TinhTrang[1].Code;
				const dialogRef = this.layoutUtilsService.POP02(_sophieu);
				dialogRef.afterClosed().subscribe((res) => {
					if (!res) {
						return;
					}
					if (data.Id > 0) {
						this.DonHangMuaService.editOrder(
							data
						).subscribe((res) =>
							this.runAfterAddOrUpdate(res, status, _sophieu, 2)
						);
					} else {
						this.DonHangMuaService.insertOrder(
							data
						).subscribe((res) =>
							this.runAfterAddOrUpdate(res, status, _sophieu, 1)
						);
					}
				});
			} else {
				data.TinhTrang_Code = this.TinhTrang[0].Code;
				if (data.Id > 0) {
					this.DonHangMuaService.editOrder(data).subscribe((res) =>
						this.runAfterAddOrUpdate(res, status, _sophieu, 2)
					);
				} else {
					this.DonHangMuaService.insertOrder(data).subscribe((res) =>
						this.runAfterAddOrUpdate(res, status, _sophieu, 1)
					);
				}
			}
		}
	}
	//#endregion

	//#region Goi sau khi service tra ve du lieu
	runAfterAddOrUpdate(res, withBack, soPhieu, type) {
		if (res && res.status == 1) {
			this.isChange = true;
			const message =
				`Đơn hàng mua ` +
				soPhieu +
				` đã được ` +
				(type == 1 ? `thêm mới` : `cập nhật`) +
				` thành công.`;
			this.layoutUtilsService.showInfo(message);

			this.DonHangMuaService.dataFormGroup$.next({});
			this.DonHangMuaService.dataListItem$.next([]);
			this.DonHangMuaService.dataListFileDinhKem$.next({});
			this.DonHangMuaService.dataListFileBangChung$.next([]);

			//Cập nhật lại khi đã thêm
			this.saveAddedTTHV = [];
			this.saveAddedTTHV.push(res.data.Id);

			if (type == 1) {
				let queryParams = new QueryParamsModel(
					{},
					"desc",
					"NGAYLAPPHIEU",
					0,
					10
				);
				this.DonHangMuaService.lastFilter$.next(queryParams);
			}

			// Luu nháp
			if (withBack == 0) {
				this.DonHangMuaItem = res.data;
				this.DonHangMuaFormInit = this.DonHangMuaForm.value;
				this.router.navigateByUrl(
					"/don-hang-mua/chinh-sua/" + res.data.Id
				);
				this.changeDetect.detectChanges();
				return;
			}

			this.checkGuiDuyet(false);
			// Lưu và thêm mới
			if (withBack == 2) {
				this.resetForm();
				this.listFileDinhKem = [];
				this.listFileBangChung = [];
				this.router.navigateByUrl("/don-hang-mua/them-moi");
				this.changeDetect.detectChanges();
				return;
			}

			// Lưu và trờ lại
			if (withBack == 1) {
				this.DonHangMuaForm.reset();
				this.tmpChiTietDonHangMua = [];
				this.tmpChiTietDonHangMua = [...this.tmpChiTietDonHangMua];
				this.back();
			}

			this.isChange = true;
			this.back();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}

	static min(min: number): ValidatorFn {
		return (control: FormControl): { [key: string]: boolean } | null => {
			let val: number = control.value;
			return { min: true };
		};
	}

	back(click: boolean = false) {
		this.dialogRef.close();
	}
	//#endregion

	//#region Reset Form
	resetForm() {
		var tenNguoiLap = "";
		this.tokenStorage.getFullName().subscribe((t) => {
			tenNguoiLap = t;
		});
		this.DonHangMuaForm.reset();
		this.DonHangMuaItem = new DonHangMua();
		this.DonHangMuaItem.Id = 0;
		this.tmpChiTietDonHangMua = [];
		this.tmpChiTietDonHangMua = [...this.tmpChiTietDonHangMua];
		this.createBillNumber().then((r) => {
			this.DonHangMuaForm.controls["SOPHIEU"].setValue(r);
		});
		this.DonHangMuaForm.controls["NGAYLAP"].setValue(new Date());
		this.DonHangMuaForm.controls["NGAYDAT"].setValue(new Date());
		this.DonHangMuaForm.controls["NGUOILAP"].setValue(tenNguoiLap);

		this.DonHangMuaForm.controls["MANCC"].setValue("");
		this.DonHangMuaForm.controls["TENNCC"].setValue("");
		this.DonHangMuaForm.controls["NGUOILIENHE"].setValue("");
		this.DonHangMuaForm.controls["DIENTHOAI"].setValue("");
		this.DonHangMuaForm.controls["DIACHI"].setValue("");

		this.DonHangMuaForm.controls["DIADIEMGIAOHANG"].setValue("");

		this.DonHangMuaForm.controls["HINHTHUCTHANHTOAN"].setValue(
			this.optionsHinhThucThanhToan
				.filter((x) => x.Default)
				.map((a) => a.Code)[0]
		);
		this.DonHangMuaForm.controls["COHOADON"].setValue(false);
		this.DonHangMuaForm.controls["PHUONGTHUCTHANHTOAN"].setValue(
			this.optionsPhuongThucThanhToan
				.filter((x) => x.Default)
				.map((a) => a.Code)[0]
		);
		this.DonHangMuaForm.controls["PHANTRAMTT"].setValue(0.0);
		this.DonHangMuaForm.controls["THOIGIANTT"].setValue(0);
		this.DonHangMuaForm.controls["SOHD"].setValue("");
		this.DonHangMuaForm.controls["BANGCHUNGNCCXACNHAN"].setValue("");
		this.DonHangMuaForm.controls["DIEUKIENGH"].setValue("");
		this.DonHangMuaForm.controls["FILENAME"].setValue("");

		this.DonHangMuaForm.controls["TRANGTHAI"].setValue(
			this.TinhTrang[0].Code
		);
		this.DonHangMuaForm.controls["DESCTRANGTHAI"].setValue(
			this.TinhTrang[0].Name
		);

		this.DonHangMuaForm.controls["LOAITIEN"].setValue(
			this.currency_unit.length > 0
				? this.currency_unit[0].Id.toString()
				: ""
		);
		this.DonHangMuaForm.controls["TYGIA"].setValue("1,00");

		this.DonHangMuaForm.controls["TONGTIENCHUATHUE"].setValue("0");
		this.DonHangMuaForm.controls["TONGTIENTHUE"].setValue("0");
		this.DonHangMuaForm.controls["TONGTIENPHAITRA"].setValue("0");

		this.DonHangMuaForm.controls["LOAIPHIEU"].setValue(
			this.optionsLoaiPhieu.filter((x) => x.Default).map((a) => a.Code)[0]
		);
		this.selectListNCC = "";
		this.DonHangMuaForm.controls["MANCC"].enable();
		this.getListDiaDiemGiaoHang();
		this.getDieuKienGiaoHang();
	}
	//#endregion

	//#region Check Invalid form
	invalidForm(formGroup) {
		const controls = formGroup.controls;
		if (formGroup.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll(
				".ng-invalid"
			);
			if (invalidElements.length > 0) {
				for (let i = 0; i < invalidElements.length; i++) {
					if (
						invalidElements[i].nodeName == "INPUT" ||
						invalidElements[i].nodeName == "MAT-SELECT"
					) {
						const elementControl = formGroup.get(
							invalidElements[i].attributes.getNamedItem(
								"formcontrolname"
							).value
						);
						if (elementControl) {
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach((controlName) =>
				controls[controlName].markAsTouched()
			);
			return false;
		}

		if (this.DonHangMuaService.data_import.getValue()) {
			var file: FileImport = this.DonHangMuaService.data_import.getValue();
			this.fileBangChung = file;
		}

		// if(this.DonHangMuaItem.BangChungNCC == 0 && !this.fileBangChung){
		// 	this.layoutUtilsService.showErorr("Vui lòng thêm bằng chứng NCC giao hàng");
		// 	return false;
		// }
	}
	//#endregion

	//#region Data form
	createItem() {
		const controls = this.DonHangMuaForm.controls;
		var data = new DonHangMua();
		data.clear();
		this.listFileDinhKem.forEach((x) => {x.fileByte = null;});
		this.listFileBangChung.forEach((x) => {x.fileByte = null;});
		data.SoPhieu = controls["SOPHIEU"].value;
		data.NgayDat = moment(controls["NGAYDAT"].value).format("YYYY-MM-DD[T]HH:mm:ss.SSS");
		data.IdNCC = +this.selectListNCC;
		data.DiaDiemGiaoHang = controls["DIADIEMGIAOHANG"].value;
		data.PayMents = controls["HINHTHUCTHANHTOAN"].value;
		data.IsCoHoaDon = controls["COHOADON"].value;
		data.IsTraTruoc = controls["PHUONGTHUCTHANHTOAN"].value == this.optionsPhuongThucThanhToan[0].Code ? true : false;
		data.DieuKienGiaoHang = controls["DIEUKIENGH"].value;
		data.TongTienChuaThue = controls["TONGTIENCHUATHUE"].value;
		data.TongTienThue = controls["TONGTIENTHUE"].value;
		data.TongTienPhaiTra = controls["TONGTIENPHAITRA"].value;
		data.IdHD = this.selectHD ? +this.selectHD : 0;
		data.ChiTiet = this.tmpChiTietDonHangMua.filter((x) => x.RecordSumAmount == false);
		data.Id = this.DonHangMuaItem.Id ? this.DonHangMuaItem.Id : 0;
		data.IsMuaTheoDeNghi = controls["LOAIPHIEU"].value == "0" ? true : false;
		data.listFileDinhKem = this.listFileDinhKem;
		data.listFileBangChung = this.listFileBangChung;
		let temp = this.listPTTT;
		temp.forEach(row => delete row.type_name);
		data.PaymentOptions = temp;
		data.GhiChu = controls['DESCRIPTION'].value;
		if (data.IsTraTruoc) data.TyLeTraTruoc = +controls["PHANTRAMTT"].value;
		else data.ThoiHanTraSau = +controls["THOIGIANTT"].value;
		this.tmpChiTietDonHangMua.forEach((x) => {
			x.TyGia = Number(this.f_number(controls["TYGIA"].value));
			x.DonVi_Id = Number(controls["LOAITIEN"].value);
		});
		return data;
	}
	//#endregion

	setDongPO() {
		const _data = {
			PhieuDatHangId: this.DonHangMuaItem.Id,
			LoaiThaoTac: this.TinhTrang[6].Code,
		};

		const _sophieu = this.DonHangMuaItem.SoPhieu;

		const dialogRef = this.layoutUtilsService.POP02(_sophieu);
		dialogRef.afterClosed().subscribe((res) => {
			if (!res) {
				return;
			}
			this.DonHangMuaService.acceptOrder(_data).subscribe((res) => {
				this.showAfterConfirm(_sophieu, res);
			});
		});
	}

	setMoPO() {
		const _data = {
			PhieuDatHangId: this.DonHangMuaItem.Id,
			LoaiThaoTac: this.TinhTrang[4].Code,
		};

		const _sophieu = this.DonHangMuaItem.SoPhieu;

		const dialogRef = this.layoutUtilsService.POP02(_sophieu);
		dialogRef.afterClosed().subscribe((res) => {
			if (!res) {
				return;
			}
			this.DonHangMuaService.openPO(_data).subscribe((res) => {
				this.showAfterConfirm(_sophieu, res);
			});
		});
	}
	//#region TP, GD Duyet, Khong Duyet
	// code 'truongphong', 'giamdoc'
	setConfirmForm(status: boolean) {
		let formGroup, code;
		formGroup = this.DonHangMuaFormDuyet;
		if (this.TinhTrang[1].Code == this.DonHangMuaItem.TinhTrang_Code) {
			code = "truongphong";
		}
		if (this.TinhTrang[2].Code == this.DonHangMuaItem.TinhTrang_Code) {
			code = "giamdockhoi";
		}

		if (this.TinhTrang[3].Code == this.DonHangMuaItem.TinhTrang_Code) {
			code = "giamdoc";
		}
		let controls = formGroup.controls;
		if (status === false) {
			if (code === "truongphong") {
				formGroup.controls["TPLYDO"].setValidators([
					Validators.compose([Validators.required]),
				]);
				formGroup.controls["TPLYDO"].updateValueAndValidity();
			}
			if (code === "giamdockhoi") {
				formGroup.controls["GDKLYDO"].setValidators([
					Validators.compose([Validators.required]),
				]);
				formGroup.controls["GDKLYDO"].updateValueAndValidity();
			}
			if (code === "giamdoc") {
				formGroup.controls["GDLYDO"].setValidators([
					Validators.compose([Validators.required]),
				]);
				formGroup.controls["GDLYDO"].updateValueAndValidity();
			}

			if (formGroup.invalid) {
				Object.keys(controls).forEach((controlName) =>
					controls[controlName].markAsTouched()
				);
				if (code === "truongphong")
					setTimeout(
						() => this.focusLyDoTP.first.nativeElement.focus(),
						0
					);
				if (code === "giamdockhoi")
					setTimeout(
						() => this.focusLyDoGDK.first.nativeElement.focus(),
						0
					);
				if (code === "giamdoc")
					setTimeout(
						() => this.focusLyDoGD.first.nativeElement.focus(),
						0
					);
				return;
			}
		}
		const _sophieu = this.DonHangMuaItem.SoPhieu;
		if (status) {
			if (code === "truongphong") {
				formGroup.controls["TPLYDO"].setValidators([
					Validators.compose([Validators.required]),
				]);
				formGroup.controls["TPLYDO"].updateValueAndValidity();
			}
			if (code === "giamdockhoi") {
				formGroup.controls["GDKLYDO"].setValidators([
					Validators.compose([Validators.required]),
				]);
				formGroup.controls["GDKLYDO"].updateValueAndValidity();
			}
			if (code === "giamdoc") {
				formGroup.controls["GDLYDO"].setValidators([
					Validators.compose([Validators.required]),
				]);
				formGroup.controls["GDLYDO"].updateValueAndValidity();
			}
			const dialogRef = this.layoutUtilsService.POP03(_sophieu);
			dialogRef.afterClosed().subscribe((res) => {
				if (!res) {
					return;
				}

				var LyDo = "";

				if (code === "truongphong") {
					LyDo = controls["TPLYDO"].value;
				}

				if (code === "giamdockhoi") {
					LyDo = controls["GDKLYDO"].value;
				}

				if (code === "giamdoc") {
					LyDo = controls["GDLYDO"].value;
				}

				const _data = {
					PhieuDatHangId: this.DonHangMuaItem.Id,
					NoiDung: LyDo,
					LoaiThaoTac:
						code == "truongphong"
							? this.TinhTrang[2].Code
							: code == "giamdockhoi"
								? this.TinhTrang[3].Code
								: this.TinhTrang[4].Code,
				};
				this.DonHangMuaService.acceptOrder(_data).subscribe((res) => {
					this.showAfterConfirm(_sophieu, res);
				});
			});
		} else {
			const dialogRef = this.layoutUtilsService.POP02(_sophieu);
			dialogRef.afterClosed().subscribe((res) => {
				if (!res) {
					return;
				}
				var LyDo = "";

				if (code === "truongphong") {
					LyDo = controls["TPLYDO"].value;
				}

				if (code === "giamdockhoi") {
					LyDo = controls["GDKLYDO"].value;
				}

				if (code === "giamdoc") {
					LyDo = controls["GDLYDO"].value;
				}
				const _data = {
					PhieuDatHangId: this.DonHangMuaItem.Id,
					NoiDung: LyDo,
					LoaiThaoTac: this.TinhTrang[5].Code,
				};
				this.DonHangMuaService.acceptOrder(_data).subscribe((res) => {
					this.showAfterConfirm(_sophieu, res);
				});
			});
		}
	}
	//#endregion

	//#region Goi sau khi duyet khong duyet
	showAfterConfirm(_sophieu, res) {
		if (res && res.status === 1) {
			const message =
				"Đơn hàng mua " + _sophieu + " cập nhật thành công.";
			this.layoutUtilsService.showInfo(message);
			this.DonHangMuaForm.reset();
			this.isChange = true;
			this.saveAddedTTHV.push(res.data.Id);
			this.back();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}
	//#endregion

	//#region set error
	// checkError(item: DonHangMuaChiTiet){
	// 	let flag = false;
	// 	if(!item.NgayDeNghiGiaoHang){
	// 		item.isError = true;
	// 		item.isMessage = 'Ngày đề nghị giao hàng là bắt buộc';
	// 		flag = true;
	// 	}
	// 	if(item.DonGia == 0 || item.DonGia == undefined || item.DonGia == null){
	// 		item.isError = true;
	// 		if(item.isMessage) item.isMessage += ",";
	// 		item.isMessage += 'Vui lòng nhập đơn giá';
	// 		flag = true;
	// 	}
	// 	if(!flag){
	// 		item.isError = false;
	// 		item.isMessage = '';
	// 	}
	// 	this.changeDetect.detectChanges();
	// }
	//#endregion

	//#region Kiểm tra định dạng số lượng
	keyUpInputNumber(event) {
		if (event.keyCode === 8 && event.target.value == "0") {
			event.preventDefault();
			return;
		}
		FunctionPublic.checkPositiveNumbers(event);
	}
	//#endregion Kiểm tra định dạng số lượng

	// changeValueOfList(controlName: string, event: any, index: number, item: DonHangMuaChiTiet){

	// 	let tmpValue = event.target.value.replace(/,/g, "");
	// 	if(!tmpValue || tmpValue == '') tmpValue = 0;
	// 	this.tmpChiTietDonHangMua[index].DonGia = this.formatNumber(tmpValue);
	// 	this.refreshList();
	// 	this.changeDetect.detectChanges();
	// }

	ValidateChangeNumberEvent(event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == ".") {
				count += 1;
			}
		}

		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = "Số lượng không gồm chữ hoặc kí tự đặc biệt";
			//this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			this.changeDetect.detectChanges();
			return false;
		}
		if (count >= 2) {
			const message = "Số lượng không thể có nhiều hơn 2 dấu .";
			//this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;
		}

		return true;
	}

	// changeInputDonGia(event,index){
	// 	let position = event.target.selectionStart;
	// 	let sizeStart = event.target.value.toString().length;
	// 	let sizeEnd = sizeStart;
	// 	var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻ���ềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
	// 	var found = event.target.value.match(regex);
	// 	if (found != null) {
	// 		event.preventDefault();
	// 	}
	// 	else{

	// 		if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 9)
	// 		{ return; }

	// 		let data = FunctionPublic.slListChanged(event);
	// 		if(data){
	// 			this.tmpChiTietDonHangMua[index].DonGia = data.replace(/,/g, "");
	// 		}else{
	// 			this.tmpChiTietDonHangMua[index].DonGia = 0;
	// 		}
	// 		this.tmpChiTietDonHangMua[index].ThanhTien = this.tmpChiTietDonHangMua[index].DonGia * this.tmpChiTietDonHangMua[index].SoLuong;
	// 		this.tmpChiTietDonHangMua[index].ThanhTienQuyDoi = this.tmpChiTietDonHangMua[index].ThanhTien * this.TitleTable.controls['TYGIA'].value.replace(/,/g, "");
	// 		this.refreshList();
	// 		this.updateMoney();
	// 		sizeEnd = data.toString().length;
	// 		let balance = sizeEnd - sizeStart;
	// 		event.target.selectionStart = position + balance;
	// 		event.target.selectionEnd = position + balance;
	// 		this.changeDetect.detectChanges();
	// 	}
	// }

	changePayments(event) {
		let tiente_id = +event.value;
		let index = this.currency_unit.findIndex((a) => a.Id === tiente_id);
		let tiente_ten = "";
		if (index > -1) tiente_ten = this.currency_unit[index].Ten;

		if (tiente_id > 0 && tiente_ten) {
			this.tmpChiTietDonHangMua.forEach((x) => {
				x.DonVi_Id = tiente_id;
				x.DonVi_Ten = tiente_ten;
			});
			//this.refreshList();
			this.changeDetect.detectChanges();
		}
	}

	// Update 27/05/2020

	ListId_HH() {
		this.DungChungService.listHangHoa().subscribe((res) => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetect.detectChanges();
			}
		});
	}
	filterId_HH(searchTmp: string = "") {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if (searchTmp != "" && searchTmp != null) search = "" + searchTmp;

		if (!search) {
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if (searchTmp != "") {
			this.filteredId_HH.next(
				this.listId_HH.filter(
					(ts) => ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1
				)
			);
		} else {
			this.filteredId_HH.next(
				this.listId_HH.filter(
					(ts) => ts.MaHang.toLowerCase().indexOf(search) > -1
				)
			);
		}
		this.changeDetect.detectChanges();
	}
	afterSelectHH(value: string) {
		let controls = this.DonHangMuaSubForm.controls;
		this.listId_HH.forEach((element) => {
			if (element.Id_HH == +value) {
				this.selectId_HH = value;
				controls["MAHH"].setValue(element.MaHH);
				controls["MAHH"].disable();
				controls["TENHH"].setValue(element.TenHH);
				controls["QUYCACH"].setValue(element.QuyCach);
				controls["DVT"].setValue(element.TenDVT);
				controls["SOLUONG"].setValue(
					this.f_currency_VND(this.formatNumber("0"))
				);
				controls["DONGIA"].setValue(
					this.f_currency_VND(this.formatNumber("0"))
				);
				controls["NGAYDENGHIGIAOHANG"].setValue(new Date());
				controls["GHICHU"].setValue("");
				//this.validateInvalidSubForm();
			}
		});
	}
	clearSelectHH(event: any) {
		let controls = this.DonHangMuaSubForm.controls;
		this.selectId_HH = "";
		controls["MAHH"].setValue("");
		controls["MAHH"].enable();
		controls["TENHH"].setValue("");
		controls["QUYCACH"].setValue("");
		controls["DVT"].setValue("");
		controls["SOLUONG"].setValue(
			this.f_currency_VND(this.formatNumber("0"))
		);
		controls["DONGIA"].setValue(
			this.f_currency_VND(this.formatNumber("0"))
		);
		controls["NGAYDENGHIGIAOHANG"].setValue(new Date());
		controls["GHICHU"].setValue("");
		event.stopPropagation();
	}

	keyUpInputNumberVND(event) {
		FunctionPublic.preventAlphaV2(event);
	}

	changeInputNumberVND(event, columnName, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		} else {
			if (
				event.keyCode === 46 ||
				event.keyCode === 37 ||
				event.keyCode === 39 ||
				event.keyCode === 8 ||
				event.keyCode === 9
			) {
				return;
			}

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (
					this.formatComparenumber(data) < min &&
					event.data &&
					event.data == "0"
				)
					data = this.f_currency_VND(
						this.formatNumber(min.toString())
					);
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
			} else {
				controls[columnName].setValue(
					this.f_currency_VND(this.formatNumber(min.toString()))
				);
			}
			if (columnName == "TYGIA") {
				this.tmpChiTietDonHangMua.forEach((x) => {
					this.updateThanhTienInRecord(x);
				});
				this.callSum();
			}
		}
	}

	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return "0,00";
		return new Intl.NumberFormat("de-DE", {
			style: "decimal",
			currency: "VND",
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		}).format(Number(value));
	}

	changeInputOfFormVND(
		controlName: string,
		event: any,
		min: number = 0,
		formGroup
	) {
		let controls = formGroup.controls;
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value
				.replace(/\./g, "")
				.replace(/,/g, ".");

			if (isNaN(tmpValue)) tmpValue = min;

			if (Number(tmpValue) < min) tmpValue = min;

			if (!controls[controlName].invalid) {
				controls[controlName].setValue(this.f_number(tmpValue));
			}

			controls[controlName].setValue(this.f_number(tmpValue));
		} else {
			controls[controlName].setValue(this.f_number(min.toString()));
		}

		this.changeDetect.detectChanges();

		if (controlName == "TYGIA") {
			this.tmpChiTietDonHangMua.forEach((x) => {
				this.updateThanhTienInRecord(x);
			});
		}

		// if(controlName == 'THUE'){
		// 	this.updateMoney();
		// }
	}

	formatComparenumber(number: string) {
		return +number.replace(/\./g, "").replace(/,/g, ".");
	}

	showErrorInputSL(columnName: string, formGroup: any, name: string) {
		let message = "";
		let controls = formGroup.controls;
		if (
			controls[columnName].value.length == 0 ||
			this.formatComparenumber(controls[columnName].value) == 0
		)
			return name + " là bắt buộc";
		if (
			controls[columnName].hasError("maxlength") ||
			(controls[columnName].value.length > 22 &&
				(controls[columnName].value.indexOf(",") == 0 ||
					controls[columnName].value.indexOf(",") > 21))
		)
			return "Tối đa 18 chữ số với 2 chữ số thập phân";
		return message;
	}

	resetSubForm() {
		let controls = this.DonHangMuaSubForm.controls;
		this.selectId_HH = "";
		controls["MAHH"].setValue("");
		controls["MAHH"].enable();
		controls["TENHH"].setValue("");
		controls["QUYCACH"].setValue("");
		controls["DVT"].setValue("");
		controls["SOLUONG"].setValue(
			this.f_currency_VND(this.formatNumber("0"))
		);
		controls["DONGIA"].setValue(
			this.f_currency_VND(this.formatNumber("0"))
		);
		controls["NGAYDENGHIGIAOHANG"].setValue(new Date());
		controls["GHICHU"].setValue("");
	}

	changeInputNumberVNDInList(event: any, min: number = 0) {
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		} else {
			if (
				event.keyCode === 46 ||
				event.keyCode === 37 ||
				event.keyCode === 39 ||
				event.keyCode === 8 ||
				event.keyCode === 9
			) {
				return;
			}

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (
					this.formatComparenumber(data) < min &&
					event.data &&
					event.data == "0"
				)
					data = this.f_currency_VND(
						this.formatNumber(min.toString())
					);
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
			} else {
				event.target.value = this.f_currency_VND(
					this.formatNumber(min.toString())
				);
			}

			//this.changeDetect.detectChanges();
		}
	}

	changeInputOfFormVNDInList(
		columnName: string,
		event: any,
		min: number = 0,
		item: DonHangMuaChiTiet
	) {
		var flag = true;
		if (columnName == "SoLuong" && item.KeHoachNCCGiaoHang.length > 0) {
			flag = false;
			const dialogRef = this.layoutUtilsService.POPConfirm(
				"Dữ liệu Kế hoạch NCC giao hàng sẽ bị mất khi thay đổi số lượng hàng hoá. Tiếp tục?"
			);
			dialogRef.afterClosed().subscribe((res) => {
				if (!res) {
					event.target.value = this.f_number(item.SoLuong);
					return;
				}

				item.KeHoachNCCGiaoHang = [];

				if (!event.target.value) {
					event.target.value = this.f_number(min);
					event.target.selectionStart = 0;
					event.target.selectionEnd = 0;
				}
				if (item[columnName]) {
					if (
						event.target.value.toString() ==
						item[columnName].toString()
					) {
						event.target.value = this.f_number(item[columnName]);
						event.target.selectionStart = 0;
						event.target.selectionEnd = 0;
					}
				}

				if (this.ValidateChangeNumberForm(event)) {
					let tmpValue = event.target.value
						.replace(/\./g, "")
						.replace(/,/g, ".");

					if (isNaN(tmpValue)) tmpValue = min;

					if (Number(tmpValue) < min) tmpValue = min;

					if (!item[columnName]) {
						item[columnName] = tmpValue;
					}

					item[columnName] = tmpValue;
				} else {
					item[columnName] = min;
				}

				this.updateThanhTienInRecord(item);

				this.checkHangHoaHopDong();

				this.checkSLWithSLConLaiHD();

				this.setDonGiaHDInList();

				this.changeDetect.detectChanges();
			});
		}

		if (flag) {
			if (!event.target.value) {
				event.target.value = this.f_number(min);
				event.target.selectionStart = 0;
				event.target.selectionEnd = 0;
			}

			if (item[columnName]) {
				if (
					event.target.value.toString() == item[columnName].toString()
				) {
					event.target.value = this.f_number(item[columnName]);
					event.target.selectionStart = 0;
					event.target.selectionEnd = 0;
				}
			}

			if (this.ValidateChangeNumberForm(event)) {
				let tmpValue = event.target.value
					.replace(/\./g, "")
					.replace(/,/g, ".");

				if (isNaN(tmpValue)) tmpValue = min;

				if (Number(tmpValue) < min) tmpValue = min;

				if (!item[columnName]) {
					item[columnName] = tmpValue;
				}

				item[columnName] = Number(tmpValue);
			} else {
				item[columnName] = min;
			}

			if (columnName == "DonGia" || columnName == "SoLuong") {
				this.updateThanhTienInRecord(item);

				this.checkHangHoaHopDong();

				this.checkSLWithSLConLaiHD();

				this.setDonGiaHDInList();
			}

			this.changeDetect.detectChanges();
		}
	}

	isCreate() {
		var idUser = "";
		this.tokenStorage.getIDUser().subscribe((t) => {
			idUser = t;
		});
		if (this.DonHangMuaItem.NguoiTao == +idUser) {
			return true;
		}
		return false;
	}

	/* Mở danh sách phiếu đề nghị */

	selectFile(formGroup: any, type: number = 1) {
		let el: HTMLElement =
			type == 1
				? (this.fileUpload1.nativeElement as HTMLElement)
				: (this.fileUpload2.nativeElement as HTMLElement);
		el.click();
		// else{
		// 	this.DonHangMuaService.downloadTemplate(this.DonHangMuaItem.Id).subscribe(blob => {
		// 		var downloadLink = document.createElement("a");
		// 		var url = URL.createObjectURL(blob);
		// 		downloadLink.href = url;
		// 		downloadLink.download = this.DonHangMuaItem.NameFile;
		// 		document.body.appendChild(downloadLink);
		// 		downloadLink.click();
		// 		document.body.removeChild(downloadLink);
		// 	});
		// }
	}

	deleteFile(item: DonHangMua) {
		this.DonHangMuaForm.controls["FILENAME"].setValue("");
		this.DonHangMuaItem.BangChungNCC = 0;
		this.changeDetect.detectChanges();
	}

	FileSelected(
		evt: any,
		type: number = 1,
		formGroup: any,
		listDetail: FileImport[]
	) {
		if (evt.target.files && evt.target.files.length) {
			const target = evt.target.files;
			var flag = true;

			if (flag) {
				let file = evt.target.files[0];
				let fileName = file.name;
				this.listFileName = fileName;
				let listFileNameStr = this.listFileName;
				formGroup.controls["FILENAME"].setValue(listFileNameStr);

				let el: any =
					type == 1
						? this.fileUpload1.nativeElement
						: this.fileUpload2.nativeElement;

				var item = new FileImport();
				item.idLoaiHH = 0;
				item.filename = listFileNameStr.toString();
				item.fileByte = file;

				this.FileDinhKemTmp = item;

				var tmp = this.FileDinhKemTmp;

				var extension = el.files[0].name.split(".").pop();

				let reader = new FileReader();
				reader.readAsDataURL(el.files[0]);
				reader.onload = function () {
					let base64Str = reader.result as string;
					var metaIdx = base64Str.indexOf(";base64,");

					base64Str = base64Str.substr(metaIdx + 8);
					var data = new FileImport();
					data.filename = fileName;
					data.base64 = base64Str;
					data.extension = extension;

					item.base64 = data.base64.toString();
					item.extension = data.extension;
					item.filename = data.filename;

					tmp.copy(item);
				};
			}
		}
		evt.target.type = "text";
		evt.target.type = "file";

		this.changeDetect.detectChanges();
	}

	addFileDinhKem(formGroup: any) {
		if (this.FileDinhKemTmp != null) {
			var flag = true;
			if (
				this.listFileDinhKem.filter(
					(x) => x.filename == this.FileDinhKemTmp.filename
				).length > 0
			) {
				flag = false;
				const dialogRef = this.layoutUtilsService.POPConfirm(
					"File " +
					this.FileDinhKemTmp.filename +
					" đính kèm đã tồn tại. Tiếp tục thêm?"
				);
				dialogRef.afterClosed().subscribe((res) => {
					if (!res) {
						formGroup.reset();
						return;
					}
					flag = true;
					this.FileDinhKemTmp.dienGiai = formGroup.controls["GHICHU"]
						.value
						? formGroup.controls["GHICHU"].value
						: "";
					this.listFileDinhKem.push(this.FileDinhKemTmp);
					this.listFileDinhKem = [...this.listFileDinhKem];
					this.listFileDinhKemInit = this.listFileDinhKem;
					formGroup.reset();
					this.FileDinhKemTmp = null;
				});
			} else {
				if (flag) {
					this.FileDinhKemTmp.dienGiai = formGroup.controls["GHICHU"]
						.value
						? formGroup.controls["GHICHU"].value
						: "";
					this.listFileDinhKem.push(this.FileDinhKemTmp);
					this.listFileDinhKem = [...this.listFileDinhKem];
					this.listFileDinhKemInit = this.listFileDinhKem;
					formGroup.reset();
					this.FileDinhKemTmp = null;
				}
			}
		}
	}

	addFileBangChung(formGroup: any) {
		if (this.FileDinhKemTmp != null) {
			var flag = true;
			if (
				this.listFileBangChung.filter(
					(x) => x.filename == this.FileDinhKemTmp.filename
				).length > 0
			) {
				flag = false;
				const dialogRef = this.layoutUtilsService.POPConfirm(
					"File " +
					this.FileDinhKemTmp.filename +
					" đính kèm đã tồn tại. Tiếp tục thêm?"
				);
				dialogRef.afterClosed().subscribe((res) => {
					if (!res) {
						formGroup.reset();
						return;
					}
					flag = true;
					this.FileDinhKemTmp.dienGiai = formGroup.controls["GHICHU"]
						.value
						? formGroup.controls["GHICHU"].value
						: "";
					this.listFileBangChung.push(this.FileDinhKemTmp);
					this.listFileBangChung = [...this.listFileBangChung];
					this.listFileBangChungInit = this.listFileBangChung;
					formGroup.reset();
					var listFile: FileImport[] = [];
					this.FileDinhKemTmp.fileByte = null;
					listFile.push(this.FileDinhKemTmp);

					if (this.DonHangMuaItem.Id > 0) {
						var data = {
							Id: this.DonHangMuaItem.Id,
							BangChungNCC: this.DonHangMuaItem.BangChungNCC
								? this.DonHangMuaItem.BangChungNCC
								: 0,
							listFile: listFile,
						};

						this.DonHangMuaService.setFileBangChung(data).subscribe(
							(res) => {
								if (res && res.status == 1) {
									this.FileDinhKemTmp = null;
									this.DonHangMuaItem.BangChungNCC =
										res.data.bangchungncc;
									this.listFileBangChung[
										this.listFileBangChung.length - 1
									].idLoaiHH = res.data.idfile;
									this.layoutUtilsService.showInfo(
										"Cập nhật file bằng chứng " +
										listFile[0].filename +
										" thành công."
									);
								} else {
									this.layoutUtilsService.showErorr(
										"Không thể thêm file bằng chứng, vui lòng thử lại"
									);
								}
							}
						);
					} else {
						this.FileDinhKemTmp = null;
					}
				});
			} else {
				if (flag) {
					this.FileDinhKemTmp.dienGiai = formGroup.controls["GHICHU"]
						.value
						? formGroup.controls["GHICHU"].value
						: "";
					this.listFileBangChung.push(this.FileDinhKemTmp);
					this.listFileBangChung = [...this.listFileBangChung];
					formGroup.reset();
					this.listFileBangChungInit = this.listFileBangChung;
					var listFile: FileImport[] = [];
					this.FileDinhKemTmp.fileByte = null;
					listFile.push(this.FileDinhKemTmp);

					if (this.DonHangMuaItem.Id > 0) {
						var data = {
							Id: this.DonHangMuaItem.Id,
							BangChungNCC: this.DonHangMuaItem.BangChungNCC
								? this.DonHangMuaItem.BangChungNCC
								: 0,
							listFile: listFile,
						};

						this.DonHangMuaService.setFileBangChung(data).subscribe(
							(res) => {
								if (res && res.status == 1) {
									this.FileDinhKemTmp = null;
									this.DonHangMuaItem.BangChungNCC =
										res.data.bangchungncc;
									this.listFileBangChung[
										this.listFileBangChung.length - 1
									].idLoaiHH = res.data.idfile;
									this.layoutUtilsService.showInfo(
										"Cập nhật file bằng chứng " +
										listFile[0].filename +
										" thành công."
									);
								} else {
									this.layoutUtilsService.showErorr(
										"Không thể thêm file bằng chứng, vui lòng thử lại"
									);
								}
							}
						);
					} else {
						this.FileDinhKemTmp = null;
					}
				}
			}
		}
	}

	getCodeNCC() {
		let name = "";
		if (this.listListNCC.length > 0) {
			var item = this.listListNCC.filter(
				(x) => x.Id_NCC == +this.DonHangMuaForm.controls["MANCC"].value
			);
			if (item.length > 0) name = item[0].MaNCC;
		}
		return name ? name : "";
	}

	changePercentThue(event: any, item: DonHangMuaChiTiet) {
		var value = event.value ? event.value : event;
		if (value) {
			var index = this.optionsPhanTramThue.findIndex(
				(x) => x.Code == value
			);
			if (index > -1) {
				item.TienThue =
					(item.ThanhTienQuyDoi *
						this.optionsPhanTramThue[index].Value) /
					100;
				this.changeDetect.detectChanges();
			}
		}

		//this.quyetDinhDuyetPOText(item);

		this.getHanMucListPhongBan();

		this.getHanMucDuyetListPhongBan();

		this.callSum();
	}

	chonHangTuDNMH() {
		this.listHanMucPB = [];
		if (this.tmpChiTietDonHangMua.length > 0) {
			const dialogRef = this.layoutUtilsService.POPConfirm("Việc thay đổi sẽ mất dữ liệu hiện có. Bạn chắc chắn muốn thay đổi?");
			dialogRef.afterClosed().subscribe((res) => {
				if (!res) return;
				this.tmpChiTietDonHangMua = [];
				this.tmpChiTietDonHangMua = [...this.tmpChiTietDonHangMua];
				this.saveTempDataInFormAndChangePage();
			});
		}
		else
		{
			this.saveTempDataInFormAndChangePage();
		}
	}

	saveTempDataInFormAndChangePage(){
		this.DonHangMuaService.dataFormGroup$.next(this.DonHangMuaForm);
		this.DonHangMuaService.dataListFileDinhKem$.next(this.listFileDinhKem);
		this.DonHangMuaService.dataListFileBangChung$.next(this.listFileBangChung);
		this.DonHangMuaService.dataListPTTT$.next(this.listPTTT);
		this.router.navigate(["ke-hoach-mua-hang", {}], {
			state: {
				IsDonHangMua: true,
				IdNCC: this.selectListNCC
					? Number(this.selectListNCC)
					: null,
				chonHangTuDNMH: true,
				chonHangTuDNTK: false,
				IdPhieu: this.DonHangMuaItem.Id,
				IdHD: this.selectHD ? Number(this.selectHD) : null,
			},
		});
	}

	chonHangTuDNTK() {
		this.listHanMucPB = [];
		if (this.tmpChiTietDonHangMua.length > 0) {
			const dialogRef = this.layoutUtilsService.POPConfirm(
				"Việc thay đổi sẽ mất dữ liệu hiện có. Bạn chắc chắn muốn thay đổi?"
			);
			dialogRef.afterClosed().subscribe((res) => {
				if (!res) {
					return;
				}
				this.tmpChiTietDonHangMua = [];
				this.tmpChiTietDonHangMua = [...this.tmpChiTietDonHangMua];

				this.DonHangMuaService.dataFormGroup$.next(this.DonHangMuaForm);
				this.DonHangMuaService.dataListFileDinhKem$.next(
					this.listFileDinhKem
				);
				this.DonHangMuaService.dataListFileBangChung$.next(
					this.listFileBangChung
				);

				this.router.navigate(["ke-hoach-mua-hang", {}], {
					state: {
						IsDonHangMua: true,
						IdNCC: Number(
							this.DonHangMuaForm.controls["MANCC"].value
						),
						chonHangTuDNTK: true,
						chonHangTuDNMH: false,
					},
				});
			});
		} else {
			this.DonHangMuaService.dataFormGroup$.next(this.DonHangMuaForm);
			this.DonHangMuaService.dataListFileDinhKem$.next(
				this.listFileDinhKem
			);
			this.DonHangMuaService.dataListFileBangChung$.next(
				this.listFileBangChung
			);
			this.router.navigate(["ke-hoach-mua-hang", {}], {
				state: {
					IsDonHangMua: true,
					IdNCC: Number(this.DonHangMuaForm.controls["MANCC"].value),
					chonHangTuDNTK: true,
					chonHangTuDNMH: false,
				},
			});
		}
	}

	// quyetDinhDuyetPOText(item: DonHangMuaChiTiet){
	// 	if(item.DonGia * Number(this.f_number(this.DonHangMuaForm.controls['TYGIA'].value)) == item.GiaDuKien || item.isCreatePO){
	// 		item.QuyetDinhDuyetPO = "Không cần duyệt";
	// 		item.QuyetDinhDuyetPOColor = "green";
	// 		return;
	// 	}

	// 	if(Number(item.DonGia)  < Number(item.DonGia + item.DonGia * item.PhanTramDungSaiGia / 100)){
	// 		item.QuyetDinhDuyetPO = "Chỉ thông báo lại BGĐ";
	// 		item.QuyetDinhDuyetPOColor = "blue";
	// 		return;
	// 	}

	// 	item.QuyetDinhDuyetPO = "BGĐ duyệt PO";
	// 	item.QuyetDinhDuyetPOColor = "black";

	// 	this.changeDetect.detectChanges();
	// }

	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}

	callSum() {
		this.sumTotalChuaThue();
		this.sumTotalThue();
		this.sumTotalPhaiTra();
	}

	sumTotalThue() {
		var sum = 0,
			sumSL = 0;
		this.tmpChiTietDonHangMua.forEach((x) => {
			sum += x.TienThue;
			sumSL += x.SoLuong;
		});
		this.sumThue = this.f_number(sum);
		this.sumSL = this.f_number(sumSL);
		this.DonHangMuaForm.controls["TONGTIENTHUE"].setValue(sum);
		this.changeDetect.detectChanges();
	}

	sumTotalChuaThue() {
		var sum = 0;
		this.tmpChiTietDonHangMua.forEach((x) => {
			sum += x.ThanhTienQuyDoi;
		});
		this.sumChuaThue = this.f_number(sum);
		this.DonHangMuaForm.controls["TONGTIENCHUATHUE"].setValue(sum);
		this.changeDetect.detectChanges();
	}

	sumTotalPhaiTra() {
		var sum1 = 0;
		var sum2 = 0;
		this.tmpChiTietDonHangMua.forEach((x) => {
			sum1 += x.TienThue;
			sum2 += x.ThanhTienQuyDoi;
		});
		this.sumCoThue = this.f_number(Number(sum1) + Number(sum2));
		this.DonHangMuaForm.controls["TONGTIENPHAITRA"].setValue(
			Number(sum1) + Number(sum2)
		);
		this.changeDetect.detectChanges();
	}

	updateThanhTienInRecord(item: DonHangMuaChiTiet) {
		item.ThanhTien = item.SoLuong * item.DonGia;
		item.ThanhTienQuyDoi =
			item.ThanhTien *
			Number(this.f_number(this.DonHangMuaForm.controls["TYGIA"].value));
		this.changePercentThue(item.PhanTramThue, item);
		this.callSum();
		this.changeDetect.detectChanges();
	}

	openKeHoachNCCGiaoHang(item: DonHangMuaChiTiet) {
		this.openFormDialog = true;
		const dialogRef = this.dialog.open(KeHoachNCCGiaoHangComponent, {
			data: {
				data: item,
				dangsoanthao: this.DonHangMuaItem.TinhTrang_Code == this.TinhTrang[0].Code,
				nguoilapphieu: this.isCreate(),
				isThaoTac: false,
			},
			maxHeight: "90vh",
			width: "70vw",
		});

		dialogRef.afterClosed().subscribe((res) => {
			item = res.data;
			this.openFormDialog = true;
			setTimeout(() => {
				this.openFormDialog = false;
			}, 50);
		});
	}

	openLichSuGiaMuaHang(item: DonHangMuaChiTiet) {
		this.openFormDialog = true;
		const dialogRef = this.dialog.open(LichSuGiaMuaHangComponent, {
			data: {
				IdHH: item.IdHH,
				Ma_Ten_HH: item.MaHH + " - " + item.TenHH,
			},
			maxHeight: "90vh",
			width: "90vw",
		});

		dialogRef.afterClosed().subscribe((res) => {
			item = res.data;
			this.openFormDialog = true;
			setTimeout(() => {
				this.openFormDialog = false;
			}, 50);
		});
	}

	openLichSuGiaoHang(item: DonHangMuaChiTiet) {
		this.openFormDialog = true;
		const dialogRef = this.dialog.open(LichSuGiaoHangComponent, {
			data: {
				IdHH: item.IdHH,
				Ma_Ten_HH:
					this.DonHangMuaItem.SoPhieu +
					" - " +
					item.MaHH +
					" - " +
					item.TenHH,
				IdCtDHB: item.Id,
			},
			maxHeight: "90vh",
			width: "90vw",
		});

		dialogRef.afterClosed().subscribe((res) => {
			item = res.data;
			this.openFormDialog = true;
			setTimeout(() => {
				this.openFormDialog = false;
			}, 50);
		});
	}

	getTenHD() {
		if (this.selectHD) {
			var element = this.listHD.findIndex(
				(x) => x.IdHD.toString() == this.selectHD
			);
			if (element > -1) {
				return (
					this.listHD[element].SoHD +
					" - " +
					this.listHD[element].TenNCC
				);
			}
		}
		return "";
	}

	duyetDonHangMua(item: DonHangMuaChiTiet) {
		this.openFormDialog = true;
		var trangThaiMHBegin = item.TrangThaiMH;
		this.DonHangMuaItem.listFileDinhKem = this.listFileDinhKem;
		const dialogRef = this.dialog.open(DuyetDonHangMuaComponent, {
			data: {
				Master: this.DonHangMuaItem,
				Detail: item,
				IdHH: item.IdHH,
				Ma_Ten_HH: item.MaHH + " - " + item.TenHH,
				IdCtDHM: item.Id,
				IsDuyet: false,
				TenHD: this.getTenHD(),
			},
			maxHeight: "90vh",
			width: "70vw",
		});
		const STATEMH_REJECT = 5;
		const STATEMH_CTPD = 1;
		const STATEMH_CDPO = 4;
		dialogRef.afterClosed().subscribe((res) => {
			if (trangThaiMHBegin != res.data.TrangThaiMH) {
				item = res.data;
				this.openFormDialog = true;
				item.IsEnable_TPDuyet = false;
				item.IsEnable_GDKDuyet = false;
				item.IsEnable_GDKTMDuyet = false;
				item.IsEnable_GDDuyet = false;
				item.TrangThaiMH = res.data.TrangThaiMH;
				let form = this.DonHangMuaForm.controls;
				let LEN_DETAIL = this.tmpChiTietDonHangMua.length;
				let LEN_REJECT = this.tmpChiTietDonHangMua.filter((x) => x.TrangThaiMH == STATEMH_REJECT).length;
				let LEN_OVER_CTPO = this.tmpChiTietDonHangMua.filter((x) => x.TrangThaiMH > STATEMH_CTPD).length;
				let LEN_WAIT_CLOSE_PO = this.tmpChiTietDonHangMua.filter((x) => x.TrangThaiMH == STATEMH_CDPO).length;
				let STATE_MASTER_REJECT = this.TinhTrang[5].Name; // 5 là thứ tự trong danh sách trạng thái "không duyệt"
				let STATE_MASTER_PROCESSING = this.TinhTrang[2].Name; // 2 là thứ tự trong danh sách trạng thái "đang thực hiện"
				let STATE_MASTER_WCLOSEPO = this.TinhTrang[4].Name; // 2 là thứ tự trong danh sách trạng thái "chờ đóng PO"
				if (LEN_REJECT == LEN_DETAIL)
					form["DESCTRANGTHAI"].setValue(STATE_MASTER_REJECT);
				else {
					if (LEN_OVER_CTPO) form["DESCTRANGTHAI"].setValue(STATE_MASTER_PROCESSING);
					if (LEN_WAIT_CLOSE_PO == (LEN_DETAIL - LEN_REJECT)) form["DESCTRANGTHAI"].setValue(STATE_MASTER_WCLOSEPO);
				}
				// Xóa check nhiều nếu có
				if(this.listChecked.length > 0){
					this.listChecked = this.listChecked.filter(_x => _x.Id != item.Id);
					this.listChecked = [...this.listChecked];
				}
				this.layoutUtilsService.showInfo("Hoàn tất quá trình duyệt");
				this.changeDetect.detectChanges();
			}
			setTimeout(() => {
				this.openFormDialog = false;
			}, 50);
		});
	}

	filterHopDong(searchTmp: string = "") {
		// get the search keyword
		let search = this.HDFilterCtrl;
		if (searchTmp != "") search = "" + searchTmp;

		if (!search) {
			this.sumRecordHD = this.listHD.length;
			this.filteredHD.next(this.listHD.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if (searchTmp != "") {
			this.sumRecordHD = this.listHD.filter(
				(ts) =>
					(ts.SoHD + " - " + ts.TenNCC)
						.toLowerCase()
						.indexOf(search) > -1
			).length;
			this.filteredHD.next(
				this.listHD.filter(
					(ts) =>
						(ts.SoHD + " - " + ts.TenNCC)
							.toLowerCase()
							.indexOf(search) > -1
				)
			);
		} else {
			this.sumRecordHD = this.listHD.filter(
				(ts) =>
					(ts.SoHD + " - " + ts.TenNCC)
						.toLowerCase()
						.indexOf(search) > -1
			).length;
			this.filteredHD.next(
				this.listHD.filter(
					(ts) =>
						(ts.SoHD + " - " + ts.TenNCC)
							.toLowerCase()
							.indexOf(search) > -1
				)
			);
		}
	}

	getDetailHD(IdHD: number = 0) {
		this.spinnerLoadDataHD = true;
		setTimeout(() => {
			this.DonHangMuaService.fillDetail(IdHD).subscribe((res) => {
				if (res && res.status === 1) {
					this.spinnerLoadDataHD = false;
					let element = res.data;
					this.dataHD = res.data;

					if (!this.dataHD.Cts) {
						this.dataHD.Cts = [];
					}

					let controls = this.DonHangMuaForm.controls;
					this.selectListNCC = element.NccId;
					controls["MANCC"].setValue(element.MaNCC);
					controls["MANCC"].disable();
					controls["TENNCC"].setValue(element.TenNCC);
					controls["NGUOILIENHE"].setValue(element.NguoiDaiDien);
					controls["DIENTHOAI"].setValue(
						element.DienThoai ? element.DienThoai : ""
					);
					controls["DIACHI"].setValue(
						element.DiaChi ? element.DiaChi : ""
					);
					if (element.DiaDiemGiaoHangId)
						this.afterSelectDDGH("" + element.DiaDiemGiaoHangId);
					controls["HINHTHUCTHANHTOAN"].setValue(
						element.PhuongThucTt
							? element.PhuongThucTt
							: this.optionsHinhThucThanhToan
								.filter((x) => x.Default)
								.map((x) => x.Code)[0]
					);
					controls["PHUONGTHUCTHANHTOAN"].setValue(
						element.IsTraTruoc == null
							? this.optionsPhuongThucThanhToan[0].Code
							: this.optionsPhuongThucThanhToan[
								element.IsTraTruoc ? 0 : 1
							].Code
					);
					this.changePhuongThucThanhToan(
						element.IsTraTruoc == null
							? this.optionsPhuongThucThanhToan[0].Code
							: this.optionsPhuongThucThanhToan[
								element.IsTraTruoc ? 0 : 1
							].Code
					);
					if (
						element.IsTraTruoc == null ||
						element.IsTraTruoc == undefined ||
						element.IsTraTruoc
					) {
						controls["PHANTRAMTT"].setValue(
							element.TyLeTraTruoc ? element.TyLeTraTruoc : 0.0
						);
					} else {
						controls["THOIGIANTT"].setValue(
							element.ThoiHanTraSau ? element.ThoiHanTraSau : 0
						);
					}
					controls["DIEUKIENGH"].setValue(
						!element.DieuKienGiaoHang
							? ""
							: element.DieuKienGiaoHang
					);

					this.listFileDinhKem = element.listFileDinhKem;

					if (element.Cts[0].TienTeId)
						controls["LOAITIEN"].setValue(
							element.Cts[0].TienTeId + ""
						);

					if (element.Cts[0].TienTeTyGia) {
						controls["TYGIA"].setValue(
							this.f_number(element.Cts[0].TienTeTyGia)
						);

						this.tmpChiTietDonHangMua.forEach((x) => {
							this.updateThanhTienInRecord(x);
						});

						this.callSum();
					}

					this.checkHangHoaHopDong();

					this.checkSLWithSLConLaiHD();

					this.setDonGiaHDInList();

					if (
						this.tmpChiTietDonHangMua.filter(
							(x) => x.IsHaveInHD == false
						).length > 0
					) {
						this.layoutUtilsService.showErorr(
							"Không được tồn tại mặt hàng không có trong hợp đồng"
						);
					}

					this.changeDetect.detectChanges();
				} else {
					this.layoutUtilsService.showErorr(
						"Có lỗi xảy ra khi lấy chi tiết hợp đồng mua hàng"
					);
				}
				this.spinnerLoadDataHD = false;
			});
		}, 1000);
	}

	getListDiaDiemGiaoHang() {
		this.ThietLapDonHangMuaService.getDataInit().subscribe((res) => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listDiaDiemGiaoHang = res.data;
				if (
					this.DonHangMuaForm.controls[
						"DIADIEMGIAOHANG"
					].value.toString()
				) {
					this.afterSelectDDGH(
						this.DonHangMuaForm.controls[
							"DIADIEMGIAOHANG"
						].value.toString()
					);
				}
				this.sumRecordA = this.listDiaDiemGiaoHang.length;
				this.filteredDiaDiemGiaoHang.next(
					this.listDiaDiemGiaoHang.slice()
				);
				this.changeDetect.detectChanges();
			}
		});
	}

	filterDiaDiemGiaoHang(searchTmp: string = "") {
		// get the search keyword
		let search = this.DiaDiemGiaoHangFilterCtrl;
		if (searchTmp != "") search = "" + searchTmp;

		if (!search) {
			this.sumRecordA = this.listDiaDiemGiaoHang.length;
			this.filteredDiaDiemGiaoHang.next(this.listDiaDiemGiaoHang.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if (searchTmp != "") {
			this.sumRecordA = this.listDiaDiemGiaoHang.filter(
				(ts) => ts.Name.toLowerCase().indexOf(search) > -1
			).length;
			this.filteredDiaDiemGiaoHang.next(
				this.listDiaDiemGiaoHang.filter(
					(ts) => ts.Name.toLowerCase().indexOf(search) > -1
				)
			);
		} else {
			this.sumRecordA = this.listDiaDiemGiaoHang.filter(
				(ts) => ts.Name.toLowerCase().indexOf(search) > -1
			).length;
			this.filteredDiaDiemGiaoHang.next(
				this.listDiaDiemGiaoHang.filter(
					(ts) => ts.Name.toLowerCase().indexOf(search) > -1
				)
			);
		}
	}

	afterSelectDDGH(value: string) {
		let controls = this.DonHangMuaForm.controls;
		this.listDiaDiemGiaoHang.forEach((element) => {
			if (element.Id == +value) {
				controls["DIADIEMGIAOHANG"].setValue(element.Name);
			}
		});
	}

	afterSelectNCC(value: string, getHD: boolean = true) {
		//this.clearSelectNCC();
		let controls = this.DonHangMuaForm.controls;
		this.listListNCC.forEach((element) => {
			if (element.Id_NCC == +value) {
				this.selectListNCC = element.Id_NCC;
				controls["MANCC"].setValue(element.MaNCC);
				controls["MANCC"].disable();
				this.DonHangMuaForm.controls["TENNCC"].setValue(element.TenNCC);
				this.DonHangMuaForm.controls["NGUOILIENHE"].setValue(
					element.NguoiLienHe
				);
				this.DonHangMuaForm.controls["DIENTHOAI"].setValue(
					element.DienThoai
				);
				this.DonHangMuaForm.controls["DIACHI"].setValue(element.DiaChi);
				//if (getHD) this.getListHopDong(+element.Id_NCC);
			}
		});
	}

	afterSelectHD(value: string, getDetail: boolean = true) {
		// if(this.selectHD) this.clearSelectHD();
		let controls = this.DonHangMuaForm.controls;
		this.listHD.forEach((element) => {
			if (element.IdHD == +value) {
				this.selectHD = element.IdHD;
				controls["SOHD"].setValue(
					element.SoHD + " - " + element.TenNCC
				);
				controls["SOHD"].disable();
				if (this.DonHangMuaFormInit)
					this.DonHangMuaFormInit["SOHD"] = "";

				//if (getDetail) this.getDetailHD(element.IdHD);
				// this.DonHangMuaService.getListHopDong(element.IdNCC).subscribe(
				// 	(res) => {
				// 		if (res && res.status === 1) {
				// 			this.listHD = res.data ? res.data : [];
				// 			this.sumRecordHD = this.listHD.length;
				// 			this.filteredHD.next(this.listHD.slice());
				// 			this.changeDetect.detectChanges();
				// 		} else {
				// 			this.layoutUtilsService.showErorr(
				// 				"Có lỗi xảy ra khi lấy danh sách hợp đồng mua hàng"
				// 			);
				// 		}
				// 	}
				// );
			}
		});
	}

	getDieuKienGiaoHang() {
		this.service.getDieuKienGiaoHang().subscribe((res) => {
			if (res && res.status == 1) {
				if (
					Object.keys(
						this.DonHangMuaService.dataFormGroup$.getValue()
					).length == 0 &&
					this.url_current == "them-moi"
				) {
					this.DonHangMuaForm.controls["DIEUKIENGH"].setValue(
						res.data
					);
					this.DonHangMuaFormInit["DIEUKIENGH"] = res.data;
					this.changeDetect.detectChanges();
				}
			} else {
				console.log(res.error.message);
				this.layoutUtilsService.showErorr(
					"Không thể lấy thông tin điều kiện giao hàng"
				);
			}
		});
	}

	updateDieuKienGiaoHang() {
		if (
			this.DonHangMuaForm.controls["DIEUKIENGH"].value &&
			this.DonHangMuaForm.controls["DIEUKIENGH"].value.toString().trim()
				.length > 0
		) {
			this.service
				.updateDieuKienGiaoHang(
					this.DonHangMuaForm.controls["DIEUKIENGH"].value
				)
				.subscribe((res) => {
					if (res && res.status == 1) {
						this.layoutUtilsService.showInfo(
							"Cập nhật điều kiện giao hàng thành công"
						);
					} else {
						console.log(res.error.message);
						this.layoutUtilsService.showErorr(
							"Không thể cập nhật điều kiện giao hàng"
						);
					}
				});
		}
	}

	addUpdateDeleteAddress(item: ThietLapDonHangMuaModel = null) {
		var Id = this.listDiaDiemGiaoHang.findIndex(
			(x) =>
				x.Id == +this.DonHangMuaForm.controls["DIADIEMGIAOHANG"].value
		);
		if (Id > -1) {
			item = this.listDiaDiemGiaoHang[Id];
		}

		if (item == null) {
			var item = new ThietLapDonHangMuaModel();
			item.clear();
			item.Name = this.DonHangMuaForm.controls["DIADIEMGIAOHANG"].value;
			item.IsDisable = false;
		}

		if (
			this.listDiaDiemGiaoHang.filter(
				(x) =>
					x.Name.trim().toLowerCase() ==
					item.Name.toString().trim().toLowerCase()
			).length > (item.Id == 0 ? 0 : 1)
		) {
			this.layoutUtilsService.showErorr("Địa điểm giao hàng đã tồn tại");
			return false;
		}
		this.service.addUpdateRemove(item).subscribe((res) => {
			if (res && res.status == 1) {
				var message = "";
				if (item.IsDisable && item.Id > 0) {
					message = "Xoá địa chỉ giao hàng thành công.";
				} else {
					if (item.Id == 0) {
						message = "Thêm mới địa chỉ giao hàng thành công.";
					} else {
						message = "Cập nhật địa chỉ giao hàng thành công.";
					}
				}
				this.layoutUtilsService.showInfo(message);
				this.getListDiaDiemGiaoHang();
			} else {
				console.log(res.error.message);
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}

	downloadFile(i: number, item: FileImport, IsFileDinhKem: number = 1) {
		if (item.idLoaiHH > 0) {
			this.DonHangMuaService.downloadTemplate(item.idLoaiHH).subscribe(
				(blob) => {
					var downloadLink = document.createElement("a");
					var url = URL.createObjectURL(blob);
					downloadLink.href = url;
					downloadLink.download = item.filename;
					document.body.appendChild(downloadLink);
					downloadLink.click();
					document.body.removeChild(downloadLink);
				}
			);
		} else {
			let objectURL;
			const file = item.fileByte;
			objectURL = URL.createObjectURL(file);
			var downloadLink = document.createElement("a");
			downloadLink.href = objectURL;
			downloadLink.download = item.filename;
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
		}
	}

	removeFileDinhKem(i: number) {
		this.listFileDinhKem.splice(i, 1);
		this.listFileDinhKem = [...this.listFileDinhKem];
		this.listFileDinhKemInit = this.listFileDinhKem;
		this.changeDetect.detectChanges();
	}

	removeFileBangChung(i: number) {
		var data = {
			Id: this.DonHangMuaItem.Id,
			BangChungNCC: this.DonHangMuaItem.BangChungNCC,
			IdFile: this.listFileBangChung[i].idLoaiHH,
		};

		var name = this.listFileBangChung[i].filename;

		this.listFileBangChung.splice(i, 1);
		this.listFileBangChung = [...this.listFileBangChung];
		this.listFileBangChungInit = this.listFileBangChung;
		if (this.DonHangMuaItem.Id > 0) {
			this.DonHangMuaService.removeFileBangChung(data).subscribe(
				(res) => {
					if (res && res.status == 1) {
						this.layoutUtilsService.showInfo(
							"File bằng chứng " + name + " đã xoá thành công"
						);
					} else {
						this.layoutUtilsService.showErorr(
							"Không thể xoá file bằng chứng, vui lòng thử lại"
						);
					}
				}
			);
		}
		this.changeDetect.detectChanges();
	}

	getNameTrangThaiMatHang(t: number) {
		switch (t) {
			case 0: {
				return "Đang soạn thảo";
			}
			case 1: {
				return "Chờ TP duyệt";
			}
			case 2: {
				return "Chờ GĐK Nhà máy duyệt";
			}
			case 3: {
				return "Chờ GĐ duyệt";
			}
			case 4: {
				return "Chờ đóng PO";
			}
			case 5: {
				return "Không duyệt";
			}
			case 6: {
				return "Hoàn tất";
			}
			case 7: {
				return "Chờ GĐK Thương mại duyệt";
			}
		}
	}

	getColorTrangThaiMatHang(t: number) {
		switch (t) {
			case 0: {
				return "#FF9900";
			}
			case 1: {
				return "#02A7F0";
			}
			case 2: {
				return "#0000FF";
			}
			case 3: {
				return "#6300BF";
			}
			case 4: {
				return "#8400FF";
			}
			case 5: {
				return "#FF0000";
			}
			case 6: {
				return "#009900";
			}
			case 7: {
				return "#0000FF";
			}
		}
	}

	showDuyetDonHangMua(item: DonHangMuaChiTiet, showPageDetail: boolean = true) {
		if (
			(this.url_current == "chi-tiet" && showPageDetail) ||
			(item.TrangThaiMH == 1 && item.IsEnable_TPDuyet) ||
			(item.TrangThaiMH == 2 && item.IsEnable_GDKDuyet)||
			(item.TrangThaiMH == 3 && item.IsEnable_GDDuyet) ||
			(item.TrangThaiMH == 7 && item.IsEnable_GDKTMDuyet)
		)
			return true;
		return false;
	}

	keHoachThemDu(item: DonHangMuaChiTiet) {
		const reducer = (accumulator, currentValue) =>
			Number(accumulator) + Number(currentValue);
		var SLDaLenKH =
			item.KeHoachNCCGiaoHang.filter((x) => x.TrangThai != "Đã huỷ")
				.length == 0
				? 0
				: item.KeHoachNCCGiaoHang.filter((x) => x.TrangThai != "Đã huỷ")
					.map((x) => x.SoLuong)
					.reduce(reducer);
		return (SLDaLenKH >= item.SoLuong && SLDaLenKH > 0) ||
			item.TrangThaiMH == 5
			? "accent"
			: "warn";
	}

	showBangChungNCCXacNhan() {
		if (this.url_current == "them-moi") return true;
		return (
			this.isCreate() &&
			(this.DonHangMuaItem.TinhTrang_Code == this.TinhTrang[0].Code ||
				this.DonHangMuaItem.TinhTrang_Code == this.TinhTrang[1].Code ||
				this.DonHangMuaItem.TinhTrang_Code == this.TinhTrang[2].Code ||
				this.DonHangMuaItem.TinhTrang_Code == this.TinhTrang[3].Code ||
				this.DonHangMuaItem.TinhTrang_Code == this.TinhTrang[4].Code)
		);
	}

	getHanMucListPhongBan() {
		if (this.listHanMucPB.length > 0) {
			this.checkHanMucPhongBan();
		} else {
			var listPB = this.tmpChiTietDonHangMua
				.map((x) => x.PhongBanSuDung_Id)
				.filter((x, i, a) => a.indexOf(x) == i);
			this.DonHangMuaService.HanMucPhongBan_Multiple(listPB).subscribe(
				(res) => {
					if (res && res.status == 1) {
						this.listHanMucPB = res.data;
						this.listHanMucPB.forEach((x) => {
							if (isNaN(x.TheoKeHoach)) x.TheoKeHoach = 0;
							if (isNaN(x.TheoNhuCau)) x.TheoNhuCau = 0;
						});
						this.checkHanMucPhongBan();
					} else {
						this.layoutUtilsService.showErorr(
							"Không thể lấy hạn mức phòng ban"
						);
					}
				}
			);
		}
	}

	checkHanMucPhongBan() {
		var listhanMucPBTmp: any[] = [];

		for (var i = 0; i < this.listHanMucPB.length; i++)
			listhanMucPBTmp.push(Object.assign({}, this.listHanMucPB[i]));

		this.tmpChiTietDonHangMua.forEach((x) => {
			x.HanMucPhongBan = 0;
			x.HanMucPhongBanNhuCau = 0;
			x.IsOverHanMucPhongBan = false;
		});

		this.tmpChiTietDonHangMua.forEach((x) => {
			if (x.PhongBanSuDung_Id > 0) {
				var SoTienCompare = 0;

				if (
					this.DonHangMuaForm.controls["LOAIPHIEU"].value ==
					this.optionsLoaiPhieu[1].Code
				) {
					SoTienCompare = x.ThanhTienQuyDoi + x.TienThue;

					x.IsCoKeHoach = true;
				} else
					SoTienCompare =
						x.ThanhTienQuyDoi +
						x.TienThue -
						x.GiaDuKien * x.SoLuongDeNghi;

				console.log(SoTienCompare, x.IsCoKeHoach);

				if (x.IsCoKeHoach) {
					var cmn =
						listhanMucPBTmp[
							listhanMucPBTmp.findIndex(
								(z) => z.IdPB == x.PhongBanSuDung_Id
							)
						].TheoKeHoach +
						(x.HanMucPhongBan - SoTienCompare);

					if (cmn < 0) {
						x.HanMucPhongBan = 0;

						x.IsOverHanMucPhongBan = true;
					} else {
						listhanMucPBTmp[
							listhanMucPBTmp.findIndex(
								(z) => z.IdPB == x.PhongBanSuDung_Id
							)
						].TheoKeHoach += x.HanMucPhongBan - SoTienCompare;

						if (
							listhanMucPBTmp[
								listhanMucPBTmp.findIndex(
									(z) => z.IdPB == x.PhongBanSuDung_Id
								)
							].TheoKeHoach < 0
						)
							x.IsOverHanMucPhongBan = true;
						else x.IsOverHanMucPhongBan = false;

						x.HanMucPhongBan = SoTienCompare;
					}
				} else {
					var cmn =
						listhanMucPBTmp[
							listhanMucPBTmp.findIndex(
								(z) => z.IdPB == x.PhongBanSuDung_Id
							)
						].TheoNhuCau +
						(x.HanMucPhongBanNhuCau - SoTienCompare);

					if (cmn < 0) {
						x.HanMucPhongBanNhuCau = 0;

						x.IsOverHanMucPhongBan = true;
					} else {
						listhanMucPBTmp[
							listhanMucPBTmp.findIndex(
								(z) => z.IdPB == x.PhongBanSuDung_Id
							)
						].TheoNhuCau += x.HanMucPhongBanNhuCau - SoTienCompare;

						if (
							listhanMucPBTmp[
								listhanMucPBTmp.findIndex(
									(z) => z.IdPB == x.PhongBanSuDung_Id
								)
							].TheoNhuCau < 0
						)
							x.IsOverHanMucPhongBan = true;
						else x.IsOverHanMucPhongBan = false;

						x.HanMucPhongBanNhuCau = SoTienCompare;
					}
				}
			}
		});
	}

	getHanMucDuyetListPhongBan() {
		if (this.listHanMucDuyetPB.length > 0) {
			this.checkHanMucDuyetPhongBan();
		} else {
			var reformattedArray = this.tmpChiTietDonHangMua.map((obj) => {
				var rObj = {};
				rObj["IdPB"] = obj.PhongBanSuDung_Id;
				rObj["IdHH"] = obj.IdHH;
				return rObj;
			});

			var unique_list = [...new Set(reformattedArray)];

			this.DonHangMuaService.HanMucDuyetPhongBan_Multiple(
				unique_list
			).subscribe((res) => {
				if (res && res.status == 1) {
					this.listHanMucDuyetPB = res.data;
					this.checkHanMucDuyetPhongBan();
				} else {
					this.layoutUtilsService.showErorr(
						"Không thể lấy hạn mức duyệt mua hàng"
					);
				}
			});
		}
	}

	checkHanMucDuyetPhongBan() {
		var listHanMucDuyetPBTmp = this.listHanMucDuyetPB.slice();

		this.tmpChiTietDonHangMua.forEach((x) => {
			if (x.PhongBanSuDung_Id > 0 && x.IdHH > 0) {
				var SoTienCompare = x.ThanhTienQuyDoi + x.TienThue;

				var MaxValue =
					listHanMucDuyetPBTmp[
						listHanMucDuyetPBTmp.findIndex(
							(a) =>
								a.IdPB == x.PhongBanSuDung_Id &&
								a.IdHH == x.IdHH
						)
					].HanMucDuyetOfLoai;

				if (MaxValue < SoTienCompare) {
					x.IsOverHanMucDuyet = true;
				} else {
					x.IsOverHanMucDuyet = false;
				}
			}
		});
	}

	checkSLWithSLConLaiHD() {
		if (this.selectHD) {
			let listSLConlaiHDTmp: any[] = [];

			for (var i = 0; i < this.dataHD.Cts.length; i++)
				listSLConlaiHDTmp.push(Object.assign({}, this.dataHD.Cts[i]));

			this.tmpChiTietDonHangMua.forEach((x) => {
				x.IsOverSLConLaiHD = false;
			});

			this.tmpChiTietDonHangMua.forEach((x) => {
				if (x.IdHH > 0 && x.SoLuong > 0) {
					if (x.IsHaveInHD) {
						var MaxValue = Number(
							listSLConlaiHDTmp[
								listSLConlaiHDTmp.findIndex(
									(a) => a.HangHoaId == x.IdHH
								)
							].SoLuongConLai.toFixed(2)
						);

						if (MaxValue < Number(x.SoLuong) && x.IsHaveInHD)
							x.IsOverSLConLaiHD = true;
						else {
							listSLConlaiHDTmp[
								listSLConlaiHDTmp.findIndex(
									(a) => a.HangHoaId == x.IdHH
								)
							].SoLuongConLai =
								Number(MaxValue) - Number(x.SoLuong);

							x.IsOverSLConLaiHD = false;
						}
					} else x.IsOverSLConLaiHD = false;
				}
			});
		} else {
			this.tmpChiTietDonHangMua.forEach((x) => {
				x.IsOverSLConLaiHD = false;
			});
		}

		this.tmpChiTietDonHangMua = [...this.tmpChiTietDonHangMua];

		this.changeDetect.detectChanges();
	}

	getHanMucDuyetMuaHang(item: DonHangMuaChiTiet) {
		if (this.listHanMucDuyetPB.length == 0) return this.f_number(0);
		return this.f_number(
			this.listHanMucDuyetPB[
				this.listHanMucDuyetPB.findIndex(
					(z) =>
						z.IdPB == item.PhongBanSuDung_Id && z.IdHH == item.IdHH
				)
			].HanMucDuyetOfLoai
		);
	}

	getTheoKeHoach(item: DonHangMuaChiTiet) {
		const reducer = (accumulator, currentValue) =>
			accumulator + currentValue;
		if (this.listHanMucPB.length == 0) return this.f_number(0);
		//+ this.tmpChiTietDonHangMua.map(a => a.HanMucPhongBan ? a.HanMucPhongBan : 0).reduce(reducer)
		return this.f_number(
			this.listHanMucPB[
				this.listHanMucPB.findIndex(
					(z) => z.IdPB == item.PhongBanSuDung_Id
				)
			].TheoKeHoach
		);
	}

	getTheoNhuCau(item: DonHangMuaChiTiet) {
		const reducer = (accumulator, currentValue) =>
			accumulator + currentValue;
		if (this.listHanMucPB.length == 0) return this.f_number(0);
		//+ this.tmpChiTietDonHangMua.map(a => a.HanMucPhongBanNhuCau ? a.HanMucPhongBanNhuCau : 0).reduce(reducer)
		return this.f_number(
			this.listHanMucPB[
				this.listHanMucPB.findIndex(
					(z) => z.IdPB == item.PhongBanSuDung_Id
				)
			].TheoNhuCau
		);
	}

	getCanhBaoHMPB(item: DonHangMuaChiTiet) {
		return item.IsOverHanMucPhongBan
			? `Mặt hàng vượt hạn mức phòng ban ` +
			(item.IsCoKeHoach
				? this.getTheoKeHoach(item)
				: this.getTheoNhuCau(item)) +
			` \n `
			: ``;
	}

	getOverSLConLaiHD(item: DonHangMuaChiTiet) {
		return item.IsOverSLConLaiHD
			? `Vượt quá SL còn lại trong hợp đồng \n `
			: ``;
	}

	showSLConLaiHD(item: DonHangMuaChiTiet) {
		return item.IsOverSLConLaiHD
			? `SL còn lại của hợp đồng là ` +
			this.getSoLuongConLai(item) +
			` \n `
			: ``;
	}

	getKhongCoTrongHD(item: DonHangMuaChiTiet) {
		return item.IsHaveInHD == false
			? `Mặt hàng không tồn tại trong hợp đồng \n `
			: ``;
	}

	getErrors(item: DonHangMuaChiTiet) {
		return (
			`` +
			this.getCanhBaoHMPB(item) +
			this.getOverSLConLaiHD(item) +
			this.showSLConLaiHD(item) +
			this.getKhongCoTrongHD(item) +
			``
		);
	}

	getSoLuongConLai(item: DonHangMuaChiTiet) {
		if (this.dataHD && this.selectHD && item.IsOverSLConLaiHD) {
			return this.dataHD.Cts.filter((x) => x.HangHoaId == item.IdHH).map(
				(a) => a.SoLuongConLai
			);
		} else {
			return 0;
		}
	}

	getStringFromHtml(text) {
		const html = text;
		const div = document.createElement("div");
		div.innerHTML = html;
		return div.textContent || div.innerText || "";
	}

	checkThayDoiCanhBao() {
		// Trờ về khi thêm mới
		var warning = false;
		
		if (
			this.listFileBangChung.length !=
			this.listFileBangChungInit.length ||
			this.listFileDinhKem.length != this.listFileDinhKemInit.length ||
			this.tmpChiTietDonHangMua.length !=
			this.tmpChiTietDonHangMuaInit.length
		)
			warning = true;

		if (warning == false)
			warning =
				JSON.stringify(this.sortKeyObject(this.DonHangMuaFormInit)) !=
				JSON.stringify(this.sortKeyObject(this.DonHangMuaForm.value));

		if (warning == false) {
			if (
				this.tmpChiTietDonHangMua.length ==
				this.DonHangMuaItem.ChiTiet.length &&
				this.DonHangMuaItem.ChiTiet.length > 0
			) {
				this.tmpChiTietDonHangMua.forEach((x) => {
					if (
						this.DonHangMuaItem.ChiTiet.findIndex(
							(a) =>
								a.Id == x.Id &&
								a.IdHH == x.IdHH &&
								a.SoLuong == x.SoLuong &&
								a.DonGia == x.DonGia &&
								a.ThanhTien == x.ThanhTien &&
								a.ThanhTienQuyDoi == x.ThanhTienQuyDoi &&
								a.PhanTramThue == x.PhanTramThue &&
								a.TienThue == x.TienThue &&
								a.GhiChu == x.GhiChu
						) == -1
					) {
						warning = true;
					}
				});
			}
		}

		return warning;
	}

	sortKeyObject(unordered: object) {
		const ordered = {};
		Object.keys(unordered)
			.sort()
			.forEach(function (key) {
				ordered[key] = unordered[key];
			});

		return ordered;
	}

	isAddUpdate() {
		return (
			this.url_current == "them-moi" || this.url_current == "chinh-sua"
		);
	}

	checkHangHoaHopDong() {
		if (this.selectHD) {
			var listHHInHD = this.dataHD.Cts.map((z) => z.HangHoaId);

			this.tmpChiTietDonHangMua.forEach((x) => {
				if (listHHInHD.filter((a) => a == x.IdHH).length == 0)
					x.IsHaveInHD = false;
				else x.IsHaveInHD = true;
			});
		} else {
			this.tmpChiTietDonHangMua.forEach((x) => {
				x.IsHaveInHD = true;
			});
		}

		this.tmpChiTietDonHangMua = [...this.tmpChiTietDonHangMua];

		this.changeDetect.detectChanges();
	}

	setDonGiaHDInList() {
		if (this.selectHD) {
			this.tmpChiTietDonHangMua.forEach((x) => {
				if (x.IsHaveInHD) {
					var dongia = this.dataHD.Cts.filter(
						(a) => a.HangHoaId == x.IdHH
					).map((z) => z.DonGia);
					var IsCoTinhThueVAT = this.dataHD.Cts.filter(
						(a) => a.HangHoaId == x.IdHH
					).map((z) => z.IsCoTinhThueVAT);
					var PhanTramThueVAT = this.dataHD.Cts.filter(
						(a) => a.HangHoaId == x.IdHH
					).map((z) => z.PhanTramThueVAT);
					if (dongia.length > 0) {
						if (dongia[0]) {
							x.DonGia = dongia[0];
						}
					}
					if (IsCoTinhThueVAT == false) {
						x.PhanTramThue = this.optionsPhanTramThue[0].Code;
					} else {
						switch (Number(PhanTramThueVAT)) {
							case 0: {
								x.PhanTramThue = this.optionsPhanTramThue[1].Code;
								break;
							}
							case 5: {
								x.PhanTramThue = this.optionsPhanTramThue[2].Code;
								break;
							}
							case 10: {
								x.PhanTramThue = this.optionsPhanTramThue[3].Code;
								break;
							}
						}
					}
					this.updateThanhTienInRecord(x);
				}
			});
		} else {
			//this.tmpChiTietDonHangMua.forEach(x => {x.DonGia = 0});
		}
		this.tmpChiTietDonHangMua = [...this.tmpChiTietDonHangMua];
		this.changeDetect.detectChanges();
	}

	clearAndSelectNCC(value: string, getHD: boolean = true) {
		this.clearSelectNCC();
		this.afterSelectNCC(value, getHD);
	}

	sum_amount(id_hh: number) {
		return this.tmpChiTietDonHangMua
			.filter((x) => x.RecordSumAmount == false && x.IdHH == id_hh)
			.map((x) => Number(x.SoLuong))
			.reduce((a, b) => a + b);
	}

	calc_index_record(item: any) {
		if (item.RecordSumAmount) return "";
		return (
			this.tmpChiTietDonHangMua
				.filter((x) => x.RecordSumAmount == false)
				.indexOf(item) + 1
		);
	}

	downloadFileTieuChuan(idHH: number) {
		if (idHH > 0) {
			let linkdownload = this.nguyenLieuService.downloadTCNPL(idHH);
			window.open(linkdownload);
		}
	}

	/*-------------------------- Export excel & print ------------------------*/
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges();
		}
	}
	ExportFileExcel() {
		this.DonHangMuaService.exportFileExcel(
			this.DonHangMuaItem.Id
		).subscribe((blob) => {
			var downloadLink = document.createElement("a");
			var url = URL.createObjectURL(blob);
			downloadLink.href = url;
			downloadLink.download = `EXPORT_${this.DonHangMuaItem.SoPhieu
				}_${moment(new Date()).format("YYYYMMDDHHmm")}`;
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
			this.waittingExport = false;
			this.changeDetectView();
		});
	}

	Print() { }
	/* -----------------------------------------------------------------------*/

	onTabChanged(event: any) {
		this.FileKemGia.controls['FILENAME'].setValue("");
		this.FileKemGia.controls['GHICHU'].setValue("");
		this.FileBangChung.controls['FILENAME'].setValue("");
		this.FileBangChung.controls['GHICHU'].setValue("");
		this.FileDinhKemTmp = null;
		this.tabIndex = event.index ? event.index : event;
		this.changeDetectView();
	}

	getBPSuDung() {
		let output = "";
		let tmp = Array.from(new Set(this.tmpChiTietDonHangMua.map(x => x.PhongBanSuDung)));
		output = tmp.filter(x => x && x != "").join(', ');
		return output;
	}

	isActionAddAndEdit(){
		const URL_ADD = "them-moi";
		const URL_EDIT = "chinh-sua";
		return this.url_current ==  URL_ADD || this.url_current == URL_EDIT;
	}

	isPaymentPostpay(){
		const DEFAULT_POSTPAY = false;
		const FIELD_METHOD_PAYMENT = "PHUONGTHUCTHANHTOAN";
		let POSTPAY = this.optionsPhuongThucThanhToan.find(_x => _x.Default == DEFAULT_POSTPAY).Code;
		return POSTPAY && this.DonHangMuaForm.controls[FIELD_METHOD_PAYMENT].value == POSTPAY;
	}

	isPaymentPrepay(){
		const DEFAULT_PREPAY = true;
		const FIELD_METHOD_PAYMENT = "PHUONGTHUCTHANHTOAN";
		let PREPAY = this.optionsPhuongThucThanhToan.find(_x => _x.Default == DEFAULT_PREPAY).Code;
		return PREPAY && this.DonHangMuaForm.controls[FIELD_METHOD_PAYMENT].value == PREPAY;
	}

	tickOne(action: boolean, item: any){
		var found = this.listChecked.find(_x => _x.Id == item.Id);
		if(action){
			if(found == null)
				this.listChecked.push(item);
		}
		else
		{
			this.listChecked = this.listChecked.filter(_x => _x.Id != item.Id);
			item.flagAccept = true;
		}
		this.listChecked = [...this.listChecked];
	}
	isCheckedOne(item: any){
		return this.listChecked.filter(_x => _x.Id == item.Id).length;
	}
	showCheckboxMultiple(){
		return this.tmpChiTietDonHangMua.filter(_x => this.showDuyetDonHangMua(_x, false)).length > 0;
	}
	tickMultiple(action: boolean){
		let allObject = JSON.parse(JSON.stringify(this.tmpChiTietDonHangMua.filter(_x => this.showDuyetDonHangMua(_x, false))));
		if(action) this.listChecked = allObject;
		else this.listChecked = [];
		this.listChecked = [...this.listChecked];
	}
	allComplete(){
		var max = this.tmpChiTietDonHangMua.filter(_x => this.showDuyetDonHangMua(_x, false)).length;
		var checked = this.listChecked.length;
		return max == checked && max > 0;
	}
	someComplete(){
		var max = this.tmpChiTietDonHangMua.filter(_x => this.showDuyetDonHangMua(_x, false)).length;
		var checked = this.listChecked.length;
		return max > checked && checked > 0;
	}
	acceptMultiple(flag: boolean = true){
		this.tmpChiTietDonHangMua.forEach(_r => {
			let indexChecked = this.listChecked.findIndex(_x => _x.Id == _r.Id);
			if(indexChecked > -1){
				_r.flagAccept = (!flag && _r.Reason && _r.Reason.length > 0) || flag;
				this.listChecked[indexChecked].flagAccept = _r.flagAccept;
				this.listChecked[indexChecked].Reason = _r.Reason;
				this.listChecked = [...this.listChecked];
			}
		});
		this.tmpChiTietDonHangMua = [...this.tmpChiTietDonHangMua];
		// Kiểm tra nếu không duyệt cần có lý do
		if(!flag && this.listChecked.filter(_x => !_x.flagAccept).length > 0)
		{
			const ERROR : string = "Vui lòng nhập lý do không duyệt";
			this.layoutUtilsService.showErorr(ERROR);
			return false;
		}
		// Setup data
		const ACCEPT: string = "DHM_DUYET_CT";
		const REJECT: string = "DHM_KHONGDUYET_CT";
		const STATEMH_REJECT = 5;
		const STATEMH_CTPD = 1;
		const STATEMH_CDPO = 4;
		let IDs = [];
		this.listChecked.forEach(x => IDs.push({PhieuDatHangCtId: x.Id, NoiDung : x.Reason && x.Reason.length > 0 ? x.Reason : "", TrangThaiMH: x.TrangThaiMH}))
		var data = {
			PhieuDatHangId: this.DonHangMuaItem.Id,
			IDs: IDs,
			LoaiThaoTac: flag ? ACCEPT : REJECT,
		}
		const dialogRef = this.layoutUtilsService.POP02(this.DonHangMuaItem.SoPhieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) return;
				this.DonHangMuaService.setChiTietDuyetDonHangMua(data).subscribe(res => {
					if(res && res.status == 1){
						this.tmpChiTietDonHangMua.forEach(_r => {
							let rev = res.data ? res.data.IDs : [];
							let checked = rev.find(_x => _x.PhieuDatHangCtId == _r.Id);
							if(checked != null) _r.TrangThaiMH = checked.TrangThaiMH;
						});
						let form = this.DonHangMuaForm.controls;
						let LEN_DETAIL = this.tmpChiTietDonHangMua.length;
						let LEN_REJECT = this.tmpChiTietDonHangMua.filter((x) => x.TrangThaiMH == STATEMH_REJECT).length;
						let LEN_OVER_CTPO = this.tmpChiTietDonHangMua.filter((x) => x.TrangThaiMH > STATEMH_CTPD).length;
						let LEN_WAIT_CLOSE_PO = this.tmpChiTietDonHangMua.filter((x) => x.TrangThaiMH == STATEMH_CDPO).length;
						let STATE_MASTER_REJECT = this.TinhTrang[5].Name; // 5 là thứ tự trong danh sách trạng thái "không duyệt"
						let STATE_MASTER_PROCESSING = this.TinhTrang[2].Name; // 2 là thứ tự trong danh sách trạng thái "đang thực hiện"
						let STATE_MASTER_WCLOSEPO = this.TinhTrang[4].Name; // 2 là thứ tự trong danh sách trạng thái "chờ đóng PO"
						if (LEN_REJECT == LEN_DETAIL)
							form["DESCTRANGTHAI"].setValue(STATE_MASTER_REJECT);
						else {
							if (LEN_OVER_CTPO) form["DESCTRANGTHAI"].setValue(STATE_MASTER_PROCESSING);
							if (LEN_WAIT_CLOSE_PO == (LEN_DETAIL - LEN_REJECT)) form["DESCTRANGTHAI"].setValue(STATE_MASTER_WCLOSEPO);
						}
						this.listChecked = [];
						this.listChecked = [...this.listChecked];
						this.tmpChiTietDonHangMua = [...this.tmpChiTietDonHangMua];
						this.layoutUtilsService.showInfo("Hoàn tất quá trình duyệt");
						this.changeDetectView();
					}else{
						this.layoutUtilsService.showErorr(res.error.message);
					}
				});
			});
		this.changeDetectView();
	}

	changeFlagAccept(item: DonHangMuaChiTiet){
		item.flagAccept = (item.Reason && item.Reason.length > 0) ? true : item.flagAccept;
		this.tmpChiTietDonHangMua = [...this.tmpChiTietDonHangMua];
		this.changeDetectView();
	}

	getValuePTTTDefault(){
		let item = this.OPTION_PTTT.find(_x => _x.default);
		if(item == null) return 0;
		return item.value;
	}

	showNoteField(){
		let value = this.PTTTForm.controls["TYPE_PAYMENT"].value;
		if(!value) return false;
		let item = this.OPTION_PTTT.find(_x => _x.req_note && _x.value.toString() == value.toString());
		if(item == null) return false;
		return true;
	}

	addInforPayment(){
		var PERCENT_MAX = 100;
		const MIN_DATE = 1;
		let mainForm = this.DonHangMuaForm.controls;
		let paymentForm = this.PTTTForm.controls;
		let inforPay = {};
		let percent = paymentForm['PER_PAYMENT'].value;
		let numberDate = paymentForm['NUMBER_DATE'].value;
		let typePay = paymentForm['TYPE_PAYMENT'].value;
		let description = paymentForm['NOTE'].value;
		let percentPrepay = mainForm['PHANTRAMTT'].value;
		this.listPTTT.forEach(x => PERCENT_MAX = PERCENT_MAX - Number(x.per_payment));
		if(this.isPaymentPrepay()) PERCENT_MAX = PERCENT_MAX - Number(percentPrepay);
		// Kiểm tra dữ liệu
		if(percent > PERCENT_MAX){
			let ERROR_OVER_MAX = "Tổng % trả vượt quá 100%";
			this.layoutUtilsService.showErorr(ERROR_OVER_MAX);
			return false;
		}
		if(numberDate < MIN_DATE){
			let ERROR_MIN_DATE = "Số ngày phải lớn hơn 1";
			this.layoutUtilsService.showErorr(ERROR_MIN_DATE);
			return false;
		}
		if(this.showNoteField() && (!description || description.toString().trim().length == 0)){
			let ERROR_DES_REQ = "Vui lòng nhập ghi chú";
			this.layoutUtilsService.showErorr(ERROR_DES_REQ);
			return false;
		}
		inforPay["per_payment"] = Number(percent);
		inforPay["number_date"] = Number(numberDate);
		inforPay["type_of_payment"] = Number(typePay);
		inforPay["type_name"] = this.getNameTypePayment(Number(typePay));
		inforPay["description"] = description ? description : "";
		mainForm["PHANTRAMTT"].disable();
		mainForm["THOIGIANTT"].disable();
		this.listPTTT.push(inforPay);
		if(this.isPaymentPostpay()) this.updateTotalDatePayment();
		this.resetPaymentForm();
		this.changeListPaymentMethods();
	}

	resetPaymentForm(){
		let paymentForm = this.PTTTForm.controls;
		paymentForm["PER_PAYMENT"].setValue(0.0);
		paymentForm["NUMBER_DATE"].setValue(0);
		paymentForm["TYPE_PAYMENT"].setValue(""+this.getValuePTTTDefault());
		paymentForm["NOTE"].setValue("");
		paymentForm['NOTE'].clearValidators();
		paymentForm['NOTE'].updateValueAndValidity();
	}

	getNameTypePayment(value: number = 0){
		if(!value) return "";
		return this.OPTION_PTTT.find(x => x.value == value).name;
	}

	deleteInforPayment(index: number = -1){
		let REMOVE = 1; // Quy tắc hàm remove của js
		if(index == -1) return;
		this.listPTTT.splice(index, REMOVE);
		this.changeListPaymentMethods();
		let mainForm = this.DonHangMuaForm.controls;
		if(this.listPTTT.length == 0) mainForm["PHANTRAMTT"].enable();
	}

	changeListPaymentMethods(setEmpty: boolean = false){
		if(setEmpty) this.listPTTT = [];
		this.listPTTT = [...this.listPTTT];
		this.changeDetectView();
	}

	updateTotalDatePayment(){
		let date = 0;
		this.listPTTT.forEach(x => date += Number(x.number_date));
		let mainForm = this.DonHangMuaForm.controls;
		mainForm["THOIGIANTT"].setValue(date);
		this.changeDetectView();
	}

	toggleNote(){
		let paymentForm = this.PTTTForm.controls;
		if(this.showNoteField()) {
			paymentForm['NOTE'].setValidators([Validators.required]);
			paymentForm['NOTE'].updateValueAndValidity();
		}else{
			paymentForm['NOTE'].clearValidators();
			paymentForm['NOTE'].updateValueAndValidity();
		}

		this.changeDetectView();
	}

	bidingData(id: number){
		if (id && id > 0) {
			let breadcrumbs = [];
			breadcrumbs = [
				{ title: "Thu mua" },
				{ title: "Đơn hàng mua", page: "/don-hang-mua" },
				{
					title: "Chi tiết",
					page: "/don-hang-mua/chi-tiet/" + id,
				},
			];
			this.subheaderService.setBreadcrumbs(breadcrumbs);
			this.DonHangMuaService.detailOrder(id).subscribe((res) => {
				if (!res || res.status == 0)
				{
					this.back();
					return;
				} else if (res && res.status == 1) {
					this.DonHangMuaItem = res.data;
					this.createFormDuyet();
					if (this.DonHangMuaForm != null) {
						this.DonHangMuaItem.Id = id;
						this.DonHangMuaForm.controls["SOPHIEU"].setValue(this.DonHangMuaItem.SoPhieu);
						this.DonHangMuaForm.controls["NGAYLAP"].setValue(this.DonHangMuaItem.ThoiGianTao);
						this.DonHangMuaForm.controls["NGUOILAP"].setValue(this.DonHangMuaItem.TenNguoiTao);
						this.DonHangMuaForm.controls["DESCTRANGTHAI"].setValue(this.DonHangMuaItem.TinhTrang_Name);
						this.DonHangMuaForm.controls["NGAYDAT"].setValue(this.DonHangMuaItem.NgayDat);
						this.DonHangMuaForm.controls["MANCC"].setValue("" + this.DonHangMuaItem.MaNCC);
						this.selectListNCC = "" + this.DonHangMuaItem.IdNCC;
						this.DonHangMuaForm.controls["MANCC"].disable();
						this.DonHangMuaForm.controls["TENNCC"].setValue("" + this.DonHangMuaItem.TenNCC);
						this.DonHangMuaForm.controls["NGUOILIENHE"].setValue("" + this.DonHangMuaItem.NguoiLienHe);
						this.DonHangMuaForm.controls["DIACHI"].setValue("" + this.DonHangMuaItem.DiaChi);
						this.DonHangMuaForm.controls["DIENTHOAI"].setValue("" + this.DonHangMuaItem.DienThoai);
						this.DonHangMuaForm.controls["DIADIEMGIAOHANG"].setValue("" + this.DonHangMuaItem.DiaDiemGiaoHang);
						this.DonHangMuaForm.controls["HINHTHUCTHANHTOAN"].setValue("" + this.DonHangMuaItem.PayMents);
						this.DonHangMuaForm.controls["COHOADON"].setValue(this.DonHangMuaItem.IsCoHoaDon);
						this.DonHangMuaForm.controls["INVOICENO"].setValue(this.DonHangMuaItem.InvoiceNo ? this.DonHangMuaItem.InvoiceNo : "");
						if (this.DonHangMuaItem.IsTraTruoc) {
							this.DonHangMuaForm.controls["PHUONGTHUCTHANHTOAN"].setValue(this.optionsPhuongThucThanhToan[0].Code);
							this.DonHangMuaForm.controls["PHANTRAMTT"].setValue(this.DonHangMuaItem.TyLeTraTruoc);
							this.changePhuongThucThanhToan(this.optionsPhuongThucThanhToan[0].Code);
						}
						else
						{
							this.DonHangMuaForm.controls["PHUONGTHUCTHANHTOAN"].setValue(this.optionsPhuongThucThanhToan[1].Code);
							this.DonHangMuaForm.controls["THOIGIANTT"].setValue(this.DonHangMuaItem.ThoiHanTraSau);
							this.changePhuongThucThanhToan(this.optionsPhuongThucThanhToan[1].Code);
						}
						this.DonHangMuaForm.controls["DIEUKIENGH"].setValue(this.DonHangMuaItem.DieuKienGiaoHang);
						this.DonHangMuaForm.controls["SOHD"].setValue(this.DonHangMuaItem.SoHD? this.DonHangMuaItem.SoHD: "");
						this.DonHangMuaForm.controls["LOAITIEN"].setValue("" + this.DonHangMuaItem.ChiTiet[0].DonVi_Id);
						this.DonHangMuaForm.controls["TYGIA"].setValue(this.f_number(this.DonHangMuaItem.ChiTiet[0].TyGia));
						this.DonHangMuaForm.controls["FILENAME"].setValue("");
						this.DonHangMuaForm.controls["DESCRIPTION"].setValue(this.DonHangMuaItem.GhiChu);
						this.DonHangMuaItem.ChiTiet.forEach((e) => {
							e.PhanTramThue = this.optionsPhanTramThue[
								e.PhanTramThue
							].Code;
							e.HanMucPhongBan = 0;
							e.HanMucPhongBanNhuCau = 0;
							e.IsOverHanMucPhongBan = false;
							e.IsCoKeHoach = e.IsCoKeHoach;
							e.RecordSumAmount = false;
						});
						for (let i = 0; i < this.DonHangMuaItem.ChiTiet.length; i++)
						{
							let tmpElement = new DonHangMuaChiTiet();
							tmpElement.clear();
							tmpElement.copy(this.DonHangMuaItem.ChiTiet[i]);
							tmpElement.flagAccept = true;
							this.tmpChiTietDonHangMua.push(tmpElement);
						}

						var arr_hh = [];
						[...new Set(this.tmpChiTietDonHangMua.map((x) => x.IdHH)),].forEach((x) => {
							var rObj = {};
							rObj["IdHH"] = x;
							rObj["Count"] = this.tmpChiTietDonHangMua.filter((z) => z.IdHH == x).length;
							arr_hh.push(rObj);
						});
						arr_hh.sort(function (a, b) {
							return b.Count - a.Count;
						});

						arr_hh.forEach((d) => {
							if (d.Count > 1) {
								var __tmp = new DonHangMuaChiTiet();
								__tmp.clear();
								__tmp.RecordSumAmount = true;
								__tmp.IdHH = d.IdHH;
								this.tmpChiTietDonHangMua.splice(
									this.tmpChiTietDonHangMua
										.map((z) => z.IdHH)
										.lastIndexOf(d.IdHH) + 1,
									0,
									__tmp
								);
							}
						});

						this.tmpChiTietDonHangMua = [...this.tmpChiTietDonHangMua,];
						this.tmpChiTietDonHangMuaInit = this.tmpChiTietDonHangMua;
						if (this.DonHangMuaItem.IdHD) this.selectHD = this.DonHangMuaItem.IdHD + "";
						this.afterSelectNCC(this.selectListNCC);
						if (this.DonHangMuaItem.IdHD && this.isAddUpdate())
							this.afterSelectHD(this.selectHD, true);
						this.listFileDinhKem = [...this.DonHangMuaItem.listFileDinhKem,];
						this.listFileDinhKemInit = this.DonHangMuaItem.listFileDinhKem;
						this.listFileBangChung = [...this.DonHangMuaItem.listFileBangChung,];
						this.listFileBangChungInit = this.DonHangMuaItem.listFileBangChung;
						this.getHanMucListPhongBan();
						this.getHanMucDuyetListPhongBan();
						this.callSum();
						this.DonHangMuaFormInit = this.DonHangMuaForm.value;
						if (!this.DonHangMuaItem.IdHD)
							this.DonHangMuaFormInit["SOHD"] = "";

						this.hinhthucthanhtoan =this.DonHangMuaItem.PayMents.split("_")[1] +" - " +
							this.DonHangMuaItem.HinhThucThanhToan_Ten +
							" " +
							(this.DonHangMuaItem.IsTraTruoc
								? "Trả trước " +
								this.DonHangMuaItem.TyLeTraTruoc +
								"%"
								: "Trả sau " +
								this.DonHangMuaItem.ThoiHanTraSau +
								" (ngày)");

						this.changeDetect.detectChanges();
					}

					// Kế hoạch về
					if (Object.keys(this.DonHangMuaService.dataFormGroup$.getValue()).length > 0) {
						var form = this.DonHangMuaService.dataFormGroup$.getValue();
						this.DonHangMuaForm = form;
					}
					if (Object.keys(this.DonHangMuaService.dataListFileDinhKem$.getValue()).length > 0)
						this.listFileDinhKem = this.DonHangMuaService.dataListFileDinhKem$.getValue();
					if (Object.keys(this.DonHangMuaService.dataListFileBangChung$.getValue()).length > 0)
						this.listFileBangChung = this.DonHangMuaService.dataListFileBangChung$.getValue();
					if (Object.keys(this.DonHangMuaService.dataListPTTT$.getValue()).length > 0)
						this.listPTTT = this.DonHangMuaService.dataListPTTT$.getValue();
					var data = window.history.state;
					if (data != null && data.IsKeHoachMuaHang) {
						data.IsData.forEach((item) => {
							item.ThanhTienQuyDoi =
								item.ThanhTien *
								Number(
									this.f_number(
										this.DonHangMuaForm.controls[			"TYGIA"
										].value
									)
								);
							item.PhanTramThue = this.optionsPhanTramThue[0].Code;
							item.TienThue =
								(item.ThanhTienQuyDoi *
									this.optionsPhanTramThue[0].Value) /
								100;
							item.QuyetDinhDuyetPO = "";
							item.QuyetDinhDuyetPOColor = "";
							//this.quyetDinhDuyetPOText(item);
						});

						var arr_hh = [];
						[
							...new Set(data.IsData.map((x) => x.IdHH)),
						].forEach((x) => {
							var rObj = {};
							rObj["IdHH"] = x;
							rObj["Count"] = data.IsData.filter(
								(z) => z.IdHH == x
							).length;
							arr_hh.push(rObj);
						});
						arr_hh.sort(function (a, b) {
							return b.Count - a.Count;
						});

						arr_hh.forEach((d) => {
							if (d.Count > 1) {
								var __tmp = new DonHangMuaChiTiet();
								__tmp.clear();
								__tmp.RecordSumAmount = true;
								__tmp.IdHH = d.IdHH;
								data.IsData.splice(
									data.IsData.map(
										(z) => z.IdHH
									).lastIndexOf(d.IdHH) + 1,
									0,
									__tmp
								);
							}
						});

						this.tmpChiTietDonHangMua = [...data.IsData];
						this.getHanMucListPhongBan();
						this.getHanMucDuyetListPhongBan();
						this.callSum();
						// Đổi loại phiếu khi add thêm dữ liệu
						var codeLoaiPhieu = this.optionsLoaiPhieu.map(
							(a) => a.Code
						)[data.LoaiPhieu == 1 ? 1 : 0];
						this.DonHangMuaForm.controls["LOAIPHIEU"].setValue(codeLoaiPhieu
						);
					}
					if (data.IdHD > 0) {
						this.selectHD = data.IdHD + "";
					}
					if (data.IdNCC > 0) {
						this.selectListNCC = data.IdNCC + "";
						this.afterSelectNCC(this.selectListNCC);
					}
					this.listPTTT = this.DonHangMuaItem.PaymentOptions;
					this.listPTTT.forEach(_x => _x.type_name = this.getNameTypePayment(Number(_x.type_of_payment)));
				}
			});
		}
	}
}
